function youmaxSaveToken(e) {
    e.status.signed_in && (youmaxLoggedInUser.youmaxAccessToken = e.access_token, jQuery(".youmax-add-comment-button").removeAttr("disabled").html('<i class="fa fa-send fa-2x"></i>'))
}(function() {
    function e() {}

    function t(e, t) {
        for (var i = e.length; i--;)
            if (e[i].listener === t) return i;
        return -1
    }

    function i(e) {
        return function() {
            return this[e].apply(this, arguments)
        }
    }
    var o = e.prototype,
        n = this,
        a = n.EventEmitter;
    o.getListeners = function(e) {
        var t, i, o = this._getEvents();
        if ("object" == typeof e) {
            t = {};
            for (i in o) o.hasOwnProperty(i) && e.test(i) && (t[i] = o[i])
        } else t = o[e] || (o[e] = []);
        return t
    }, o.flattenListeners = function(e) {
        var t, i = [];
        for (t = 0; t < e.length; t += 1) i.push(e[t].listener);
        return i
    }, o.getListenersAsObject = function(e) {
        var t, i = this.getListeners(e);
        return i instanceof Array && (t = {}, t[e] = i), t || i
    }, o.addListener = function(e, i) {
        var o, n = this.getListenersAsObject(e),
            a = "object" == typeof i;
        for (o in n) n.hasOwnProperty(o) && -1 === t(n[o], i) && n[o].push(a ? i : {
            listener: i,
            once: !1
        });
        return this
    }, o.on = i("addListener"), o.addOnceListener = function(e, t) {
        return this.addListener(e, {
            listener: t,
            once: !0
        })
    }, o.once = i("addOnceListener"), o.defineEvent = function(e) {
        return this.getListeners(e), this
    }, o.defineEvents = function(e) {
        for (var t = 0; t < e.length; t += 1) this.defineEvent(e[t]);
        return this
    }, o.removeListener = function(e, i) {
        var o, n, a = this.getListenersAsObject(e);
        for (n in a) a.hasOwnProperty(n) && (o = t(a[n], i), -1 !== o && a[n].splice(o, 1));
        return this
    }, o.off = i("removeListener"), o.addListeners = function(e, t) {
        return this.manipulateListeners(!1, e, t)
    }, o.removeListeners = function(e, t) {
        return this.manipulateListeners(!0, e, t)
    }, o.manipulateListeners = function(e, t, i) {
        var o, n, a = e ? this.removeListener : this.addListener,
            s = e ? this.removeListeners : this.addListeners;
        if ("object" != typeof t || t instanceof RegExp)
            for (o = i.length; o--;) a.call(this, t, i[o]);
        else
            for (o in t) t.hasOwnProperty(o) && (n = t[o]) && ("function" == typeof n ? a.call(this, o, n) : s.call(this, o, n));
        return this
    }, o.removeEvent = function(e) {
        var t, i = typeof e,
            o = this._getEvents();
        if ("string" === i) delete o[e];
        else if ("object" === i)
            for (t in o) o.hasOwnProperty(t) && e.test(t) && delete o[t];
        else delete this._events;
        return this
    }, o.removeAllListeners = i("removeEvent"), o.emitEvent = function(e, t) {
        var i, o, n, a, s = this.getListenersAsObject(e);
        for (n in s)
            if (s.hasOwnProperty(n))
                for (o = s[n].length; o--;) i = s[n][o], i.once === !0 && this.removeListener(e, i.listener), a = i.listener.apply(this, t || []), a === this._getOnceReturnValue() && this.removeListener(e, i.listener);
        return this
    }, o.trigger = i("emitEvent"), o.emit = function(e) {
        var t = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(e, t)
    }, o.setOnceReturnValue = function(e) {
        return this._onceReturnValue = e, this
    }, o._getOnceReturnValue = function() {
        return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
    }, o._getEvents = function() {
        return this._events || (this._events = {})
    }, e.noConflict = function() {
        return n.EventEmitter = a, e
    }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function() {
        return e
    }) : "object" == typeof module && module.exports ? module.exports = e : this.EventEmitter = e
}).call(this),
    function(e) {
        function t(t) {
            var i = e.event;
            return i.target = i.target || i.srcElement || t, i
        }
        var i = document.documentElement,
            o = function() {};
        i.addEventListener ? o = function(e, t, i) {
            e.addEventListener(t, i, !1)
        } : i.attachEvent && (o = function(e, i, o) {
            e[i + o] = o.handleEvent ? function() {
                var i = t(e);
                o.handleEvent.call(o, i)
            } : function() {
                var i = t(e);
                o.call(e, i)
            }, e.attachEvent("on" + i, e[i + o])
        });
        var n = function() {};
        i.removeEventListener ? n = function(e, t, i) {
            e.removeEventListener(t, i, !1)
        } : i.detachEvent && (n = function(e, t, i) {
            e.detachEvent("on" + t, e[t + i]);
            try {
                delete e[t + i]
            } catch (o) {
                e[t + i] = void 0
            }
        });
        var a = {
            bind: o,
            unbind: n
        };
        "function" == typeof define && define.amd ? define("eventie/eventie", a) : e.eventie = a
    }(this),
    function(e, t) {
        "function" == typeof define && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], function(i, o) {
            return t(e, i, o)
        }) : "object" == typeof exports ? module.exports = t(e, require("wolfy87-eventemitter"), require("eventie")) : e.imagesLoaded = t(e, e.EventEmitter, e.eventie)
    }(window, function(e, t, i) {
        function o(e, t) {
            for (var i in t) e[i] = t[i];
            return e
        }

        function n(e) {
            return "[object Array]" === p.call(e)
        }

        function a(e) {
            var t = [];
            if (n(e)) t = e;
            else if ("number" == typeof e.length)
                for (var i = 0, o = e.length; o > i; i++) t.push(e[i]);
            else t.push(e);
            return t
        }

        function s(e, t, i) {
            if (!(this instanceof s)) return new s(e, t);
            "string" == typeof e && (e = document.querySelectorAll(e)), this.elements = a(e), this.options = o({}, this.options), "function" == typeof t ? i = t : o(this.options, t), i && this.on("always", i), this.getImages(), d && (this.jqDeferred = new d.Deferred);
            var n = this;
            setTimeout(function() {
                n.check()
            })
        }

        function r(e) {
            this.img = e
        }

        function l(e) {
            this.src = e, m[e] = this
        }
        var d = e.jQuery,
            u = e.console,
            c = "undefined" != typeof u,
            p = Object.prototype.toString;
        s.prototype = new t, s.prototype.options = {}, s.prototype.getImages = function() {
            this.images = [];
            for (var e = 0, t = this.elements.length; t > e; e++) {
                var i = this.elements[e];
                "IMG" === i.nodeName && this.addImage(i);
                var o = i.nodeType;
                if (o && (1 === o || 9 === o || 11 === o))
                    for (var n = i.querySelectorAll("img"), a = 0, s = n.length; s > a; a++) {
                        var r = n[a];
                        this.addImage(r)
                    }
            }
        }, s.prototype.addImage = function(e) {
            var t = new r(e);
            this.images.push(t)
        }, s.prototype.check = function() {
            function e(e, n) {
                return t.options.debug && c && u.log("confirm", e, n), t.progress(e), i++, i === o && t.complete(), !0
            }
            var t = this,
                i = 0,
                o = this.images.length;
            if (this.hasAnyBroken = !1, !o) return void this.complete();
            for (var n = 0; o > n; n++) {
                var a = this.images[n];
                a.on("confirm", e), a.check()
            }
        }, s.prototype.progress = function(e) {
            this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
            var t = this;
            setTimeout(function() {
                t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify && t.jqDeferred.notify(t, e)
            })
        }, s.prototype.complete = function() {
            var e = this.hasAnyBroken ? "fail" : "done";
            this.isComplete = !0;
            var t = this;
            setTimeout(function() {
                if (t.emit(e, t), t.emit("always", t), t.jqDeferred) {
                    var i = t.hasAnyBroken ? "reject" : "resolve";
                    t.jqDeferred[i](t)
                }
            })
        }, d && (d.fn.imagesLoaded = function(e, t) {
            var i = new s(this, e, t);
            return i.jqDeferred.promise(d(this))
        }), r.prototype = new t, r.prototype.check = function() {
            var e = m[this.img.src] || new l(this.img.src);
            if (e.isConfirmed) return void this.confirm(e.isLoaded, "cached was confirmed");
            if (this.img.complete && void 0 !== this.img.naturalWidth) return void this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
            var t = this;
            e.on("confirm", function(e, i) {
                return t.confirm(e.isLoaded, i), !0
            }), e.check()
        }, r.prototype.confirm = function(e, t) {
            this.isLoaded = e, this.emit("confirm", this, t)
        };
        var m = {};
        return l.prototype = new t, l.prototype.check = function() {
            if (!this.isChecked) {
                var e = new Image;
                i.bind(e, "load", this), i.bind(e, "error", this), e.src = this.src, this.isChecked = !0
            }
        }, l.prototype.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, l.prototype.onload = function(e) {
            this.confirm(!0, "onload"), this.unbindProxyEvents(e)
        }, l.prototype.onerror = function(e) {
            this.confirm(!1, "onerror"), this.unbindProxyEvents(e)
        }, l.prototype.confirm = function(e, t) {
            this.isConfirmed = !0, this.isLoaded = e, this.emit("confirm", this, t)
        }, l.prototype.unbindProxyEvents = function(e) {
            i.unbind(e.target, "load", this), i.unbind(e.target, "error", this)
        }, s
    }),
    function(e) {
        function t() {}

        function i(e) {
            function i(t) {
                t.prototype.option || (t.prototype.option = function(t) {
                    e.isPlainObject(t) && (this.options = e.extend(!0, this.options, t))
                })
            }

            function n(t, i) {
                e.fn[t] = function(n) {
                    if ("string" == typeof n) {
                        for (var s = o.call(arguments, 1), r = 0, l = this.length; l > r; r++) {
                            var d = this[r],
                                u = e.data(d, t);
                            if (u)
                                if (e.isFunction(u[n]) && "_" !== n.charAt(0)) {
                                    var c = u[n].apply(u, s);
                                    if (void 0 !== c) return c
                                } else a("no such method '" + n + "' for " + t + " instance");
                            else a("cannot call methods on " + t + " prior to initialization; attempted to call '" + n + "'")
                        }
                        return this
                    }
                    return this.each(function() {
                        var o = e.data(this, t);
                        o ? (o.option(n), o._init()) : (o = new i(this, n), e.data(this, t, o))
                    })
                }
            }
            if (e) {
                var a = "undefined" == typeof console ? t : function(e) {
                    console.error(e)
                };
                return e.bridget = function(e, t) {
                    i(t), n(e, t)
                }, e.bridget
            }
        }
        var o = Array.prototype.slice;
        "function" == typeof define && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], i) : i("object" == typeof exports ? require("jquery") : e.jQuery)
    }(window),
    function(e) {
        function t(t) {
            var i = e.event;
            return i.target = i.target || i.srcElement || t, i
        }
        var i = document.documentElement,
            o = function() {};
        i.addEventListener ? o = function(e, t, i) {
            e.addEventListener(t, i, !1)
        } : i.attachEvent && (o = function(e, i, o) {
            e[i + o] = o.handleEvent ? function() {
                var i = t(e);
                o.handleEvent.call(o, i)
            } : function() {
                var i = t(e);
                o.call(e, i)
            }, e.attachEvent("on" + i, e[i + o])
        });
        var n = function() {};
        i.removeEventListener ? n = function(e, t, i) {
            e.removeEventListener(t, i, !1)
        } : i.detachEvent && (n = function(e, t, i) {
            e.detachEvent("on" + t, e[t + i]);
            try {
                delete e[t + i]
            } catch (o) {
                e[t + i] = void 0
            }
        });
        var a = {
            bind: o,
            unbind: n
        };
        "function" == typeof define && define.amd ? define("eventie/eventie", a) : "object" == typeof exports ? module.exports = a : e.eventie = a
    }(window),
    function() {
        function e() {}

        function t(e, t) {
            for (var i = e.length; i--;)
                if (e[i].listener === t) return i;
            return -1
        }

        function i(e) {
            return function() {
                return this[e].apply(this, arguments)
            }
        }
        var o = e.prototype,
            n = this,
            a = n.EventEmitter;
        o.getListeners = function(e) {
            var t, i, o = this._getEvents();
            if (e instanceof RegExp) {
                t = {};
                for (i in o) o.hasOwnProperty(i) && e.test(i) && (t[i] = o[i])
            } else t = o[e] || (o[e] = []);
            return t
        }, o.flattenListeners = function(e) {
            var t, i = [];
            for (t = 0; t < e.length; t += 1) i.push(e[t].listener);
            return i
        }, o.getListenersAsObject = function(e) {
            var t, i = this.getListeners(e);
            return i instanceof Array && (t = {}, t[e] = i), t || i
        }, o.addListener = function(e, i) {
            var o, n = this.getListenersAsObject(e),
                a = "object" == typeof i;
            for (o in n) n.hasOwnProperty(o) && -1 === t(n[o], i) && n[o].push(a ? i : {
                listener: i,
                once: !1
            });
            return this
        }, o.on = i("addListener"), o.addOnceListener = function(e, t) {
            return this.addListener(e, {
                listener: t,
                once: !0
            })
        }, o.once = i("addOnceListener"), o.defineEvent = function(e) {
            return this.getListeners(e), this
        }, o.defineEvents = function(e) {
            for (var t = 0; t < e.length; t += 1) this.defineEvent(e[t]);
            return this
        }, o.removeListener = function(e, i) {
            var o, n, a = this.getListenersAsObject(e);
            for (n in a) a.hasOwnProperty(n) && (o = t(a[n], i), -1 !== o && a[n].splice(o, 1));
            return this
        }, o.off = i("removeListener"), o.addListeners = function(e, t) {
            return this.manipulateListeners(!1, e, t)
        }, o.removeListeners = function(e, t) {
            return this.manipulateListeners(!0, e, t)
        }, o.manipulateListeners = function(e, t, i) {
            var o, n, a = e ? this.removeListener : this.addListener,
                s = e ? this.removeListeners : this.addListeners;
            if ("object" != typeof t || t instanceof RegExp)
                for (o = i.length; o--;) a.call(this, t, i[o]);
            else
                for (o in t) t.hasOwnProperty(o) && (n = t[o]) && ("function" == typeof n ? a.call(this, o, n) : s.call(this, o, n));
            return this
        }, o.removeEvent = function(e) {
            var t, i = typeof e,
                o = this._getEvents();
            if ("string" === i) delete o[e];
            else if (e instanceof RegExp)
                for (t in o) o.hasOwnProperty(t) && e.test(t) && delete o[t];
            else delete this._events;
            return this
        }, o.removeAllListeners = i("removeEvent"), o.emitEvent = function(e, t) {
            var i, o, n, a, s = this.getListenersAsObject(e);
            for (n in s)
                if (s.hasOwnProperty(n))
                    for (o = s[n].length; o--;) i = s[n][o], i.once === !0 && this.removeListener(e, i.listener), a = i.listener.apply(this, t || []), a === this._getOnceReturnValue() && this.removeListener(e, i.listener);
            return this
        }, o.trigger = i("emitEvent"), o.emit = function(e) {
            var t = Array.prototype.slice.call(arguments, 1);
            return this.emitEvent(e, t)
        }, o.setOnceReturnValue = function(e) {
            return this._onceReturnValue = e, this
        }, o._getOnceReturnValue = function() {
            return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
        }, o._getEvents = function() {
            return this._events || (this._events = {})
        }, e.noConflict = function() {
            return n.EventEmitter = a, e
        }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function() {
            return e
        }) : "object" == typeof module && module.exports ? module.exports = e : n.EventEmitter = e
    }.call(this),
    function(e) {
        function t(e) {
            if (e) {
                if ("string" == typeof o[e]) return e;
                e = e.charAt(0).toUpperCase() + e.slice(1);
                for (var t, n = 0, a = i.length; a > n; n++)
                    if (t = i[n] + e, "string" == typeof o[t]) return t
            }
        }
        var i = "Webkit Moz ms Ms O".split(" "),
            o = document.documentElement.style;
        "function" == typeof define && define.amd ? define("get-style-property/get-style-property", [], function() {
            return t
        }) : "object" == typeof exports ? module.exports = t : e.getStyleProperty = t
    }(window),
    function(e, t) {
        function i(e) {
            var t = parseFloat(e),
                i = -1 === e.indexOf("%") && !isNaN(t);
            return i && t
        }

        function o() {}

        function n() {
            for (var e = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, t = 0, i = r.length; i > t; t++) {
                var o = r[t];
                e[o] = 0
            }
            return e
        }

        function a(t) {
            function o() {
                if (!p) {
                    p = !0;
                    var o = e.getComputedStyle;
                    if (d = function() {
                            var e = o ? function(e) {
                                return o(e, null)
                            } : function(e) {
                                return e.currentStyle
                            };
                            return function(t) {
                                var i = e(t);
                                return i || s("Style returned " + i + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), i
                            }
                        }(), u = t("boxSizing")) {
                        var n = document.createElement("div");
                        n.style.width = "200px", n.style.padding = "1px 2px 3px 4px", n.style.borderStyle = "solid", n.style.borderWidth = "1px 2px 3px 4px", n.style[u] = "border-box";
                        var a = document.body || document.documentElement;
                        a.appendChild(n);
                        var r = d(n);
                        c = 200 === i(r.width), a.removeChild(n)
                    }
                }
            }

            function a(e) {
                if (o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) {
                    var t = d(e);
                    if ("none" === t.display) return n();
                    var a = {};
                    a.width = e.offsetWidth, a.height = e.offsetHeight;
                    for (var s = a.isBorderBox = !(!u || !t[u] || "border-box" !== t[u]), p = 0, m = r.length; m > p; p++) {
                        var h = r[p],
                            f = t[h];
                        f = l(e, f);
                        var y = parseFloat(f);
                        a[h] = isNaN(y) ? 0 : y
                    }
                    var v = a.paddingLeft + a.paddingRight,
                        x = a.paddingTop + a.paddingBottom,
                        g = a.marginLeft + a.marginRight,
                        b = a.marginTop + a.marginBottom,
                        _ = a.borderLeftWidth + a.borderRightWidth,
                        w = a.borderTopWidth + a.borderBottomWidth,
                        C = s && c,
                        k = i(t.width);
                    k !== !1 && (a.width = k + (C ? 0 : v + _));
                    var T = i(t.height);
                    return T !== !1 && (a.height = T + (C ? 0 : x + w)), a.innerWidth = a.width - (v + _), a.innerHeight = a.height - (x + w), a.outerWidth = a.width + g, a.outerHeight = a.height + b, a
                }
            }

            function l(t, i) {
                if (e.getComputedStyle || -1 === i.indexOf("%")) return i;
                var o = t.style,
                    n = o.left,
                    a = t.runtimeStyle,
                    s = a && a.left;
                return s && (a.left = t.currentStyle.left), o.left = i, i = o.pixelLeft, o.left = n, s && (a.left = s), i
            }
            var d, u, c, p = !1;
            return a
        }
        var s = "undefined" == typeof console ? o : function(e) {
                console.error(e)
            },
            r = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
        "function" == typeof define && define.amd ? define("get-size/get-size", ["get-style-property/get-style-property"], a) : "object" == typeof exports ? module.exports = a(require("desandro-get-style-property")) : e.getSize = a(e.getStyleProperty)
    }(window),
    function(e) {
        function t(e) {
            "function" == typeof e && (t.isReady ? e() : s.push(e))
        }

        function i(e) {
            var i = "readystatechange" === e.type && "complete" !== a.readyState;
            t.isReady || i || o()
        }

        function o() {
            t.isReady = !0;
            for (var e = 0, i = s.length; i > e; e++) {
                var o = s[e];
                o()
            }
        }

        function n(n) {
            return "complete" === a.readyState ? o() : (n.bind(a, "DOMContentLoaded", i), n.bind(a, "readystatechange", i), n.bind(e, "load", i)), t
        }
        var a = e.document,
            s = [];
        t.isReady = !1, "function" == typeof define && define.amd ? define("doc-ready/doc-ready", ["eventie/eventie"], n) : "object" == typeof exports ? module.exports = n(require("eventie")) : e.docReady = n(e.eventie)
    }(window),
    function(e) {
        function t(e, t) {
            return e[s](t)
        }

        function i(e) {
            if (!e.parentNode) {
                var t = document.createDocumentFragment();
                t.appendChild(e)
            }
        }

        function o(e, t) {
            i(e);
            for (var o = e.parentNode.querySelectorAll(t), n = 0, a = o.length; a > n; n++)
                if (o[n] === e) return !0;
            return !1
        }

        function n(e, o) {
            return i(e), t(e, o)
        }
        var a, s = function() {
            if (e.matches) return "matches";
            if (e.matchesSelector) return "matchesSelector";
            for (var t = ["webkit", "moz", "ms", "o"], i = 0, o = t.length; o > i; i++) {
                var n = t[i],
                    a = n + "MatchesSelector";
                if (e[a]) return a
            }
        }();
        if (s) {
            var r = document.createElement("div"),
                l = t(r, "div");
            a = l ? t : n
        } else a = o;
        "function" == typeof define && define.amd ? define("matches-selector/matches-selector", [], function() {
            return a
        }) : "object" == typeof exports ? module.exports = a : window.matchesSelector = a
    }(Element.prototype),
    function(e, t) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["doc-ready/doc-ready", "matches-selector/matches-selector"], function(i, o) {
            return t(e, i, o)
        }) : "object" == typeof exports ? module.exports = t(e, require("doc-ready"), require("desandro-matches-selector")) : e.fizzyUIUtils = t(e, e.docReady, e.matchesSelector)
    }(window, function(e, t, i) {
        var o = {};
        o.extend = function(e, t) {
            for (var i in t) e[i] = t[i];
            return e
        }, o.modulo = function(e, t) {
            return (e % t + t) % t
        };
        var n = Object.prototype.toString;
        o.isArray = function(e) {
            return "[object Array]" == n.call(e)
        }, o.makeArray = function(e) {
            var t = [];
            if (o.isArray(e)) t = e;
            else if (e && "number" == typeof e.length)
                for (var i = 0, n = e.length; n > i; i++) t.push(e[i]);
            else t.push(e);
            return t
        }, o.indexOf = Array.prototype.indexOf ? function(e, t) {
            return e.indexOf(t)
        } : function(e, t) {
            for (var i = 0, o = e.length; o > i; i++)
                if (e[i] === t) return i;
            return -1
        }, o.removeFrom = function(e, t) {
            var i = o.indexOf(e, t); - 1 != i && e.splice(i, 1)
        }, o.isElement = "function" == typeof HTMLElement || "object" == typeof HTMLElement ? function(e) {
            return e instanceof HTMLElement
        } : function(e) {
            return e && "object" == typeof e && 1 == e.nodeType && "string" == typeof e.nodeName
        }, o.setText = function() {
            function e(e, i) {
                t = t || (void 0 !== document.documentElement.textContent ? "textContent" : "innerText"), e[t] = i
            }
            var t;
            return e
        }(), o.getParent = function(e, t) {
            for (; e != document.body;)
                if (e = e.parentNode, i(e, t)) return e
        }, o.getQueryElement = function(e) {
            return "string" == typeof e ? document.querySelector(e) : e
        }, o.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, o.filterFindElements = function(e, t) {
            e = o.makeArray(e);
            for (var n = [], a = 0, s = e.length; s > a; a++) {
                var r = e[a];
                if (o.isElement(r))
                    if (t) {
                        i(r, t) && n.push(r);
                        for (var l = r.querySelectorAll(t), d = 0, u = l.length; u > d; d++) n.push(l[d])
                    } else n.push(r)
            }
            return n
        }, o.debounceMethod = function(e, t, i) {
            var o = e.prototype[t],
                n = t + "Timeout";
            e.prototype[t] = function() {
                var e = this[n];
                e && clearTimeout(e);
                var t = arguments,
                    a = this;
                this[n] = setTimeout(function() {
                    o.apply(a, t), delete a[n]
                }, i || 100)
            }
        }, o.toDashed = function(e) {
            return e.replace(/(.)([A-Z])/g, function(e, t, i) {
                return t + "-" + i
            }).toLowerCase()
        };
        var a = e.console;
        return o.htmlInit = function(i, n) {
            t(function() {
                for (var t = o.toDashed(n), s = document.querySelectorAll(".js-" + t), r = "data-" + t + "-options", l = 0, d = s.length; d > l; l++) {
                    var u, c = s[l],
                        p = c.getAttribute(r);
                    try {
                        u = p && JSON.parse(p)
                    } catch (m) {
                        a && a.error("Error parsing " + r + " on " + c.nodeName.toLowerCase() + (c.id ? "#" + c.id : "") + ": " + m);
                        continue
                    }
                    var h = new i(c, u),
                        f = e.jQuery;
                    f && f.data(c, n, h)
                }
            })
        }, o
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("outlayer/item", ["eventEmitter/EventEmitter", "get-size/get-size", "get-style-property/get-style-property", "fizzy-ui-utils/utils"], function(i, o, n, a) {
            return t(e, i, o, n, a)
        }) : "object" == typeof exports ? module.exports = t(e, require("wolfy87-eventemitter"), require("get-size"), require("desandro-get-style-property"), require("fizzy-ui-utils")) : (e.Outlayer = {}, e.Outlayer.Item = t(e, e.EventEmitter, e.getSize, e.getStyleProperty, e.fizzyUIUtils))
    }(window, function(e, t, i, o, n) {
        function a(e) {
            for (var t in e) return !1;
            return t = null, !0
        }

        function s(e, t) {
            e && (this.element = e, this.layout = t, this.position = {
                x: 0,
                y: 0
            }, this._create())
        }

        function r(e) {
            return e.replace(/([A-Z])/g, function(e) {
                return "-" + e.toLowerCase()
            })
        }
        var l = e.getComputedStyle,
            d = l ? function(e) {
                return l(e, null)
            } : function(e) {
                return e.currentStyle
            },
            u = o("transition"),
            c = o("transform"),
            p = u && c,
            m = !!o("perspective"),
            h = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "otransitionend",
                transition: "transitionend"
            }[u],
            f = ["transform", "transition", "transitionDuration", "transitionProperty"],
            y = function() {
                for (var e = {}, t = 0, i = f.length; i > t; t++) {
                    var n = f[t],
                        a = o(n);
                    a && a !== n && (e[n] = a)
                }
                return e
            }();
        n.extend(s.prototype, t.prototype), s.prototype._create = function() {
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            }, this.css({
                position: "absolute"
            })
        }, s.prototype.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, s.prototype.getSize = function() {
            this.size = i(this.element)
        }, s.prototype.css = function(e) {
            var t = this.element.style;
            for (var i in e) {
                var o = y[i] || i;
                t[o] = e[i]
            }
        }, s.prototype.getPosition = function() {
            var e = d(this.element),
                t = this.layout.options,
                i = t.isOriginLeft,
                o = t.isOriginTop,
                n = e[i ? "left" : "right"],
                a = e[o ? "top" : "bottom"],
                s = parseInt(n, 10),
                r = parseInt(a, 10),
                l = this.layout.size;
            s = -1 != n.indexOf("%") ? s / 100 * l.width : s, r = -1 != a.indexOf("%") ? r / 100 * l.height : r, s = isNaN(s) ? 0 : s, r = isNaN(r) ? 0 : r, s -= i ? l.paddingLeft : l.paddingRight, r -= o ? l.paddingTop : l.paddingBottom, this.position.x = s, this.position.y = r
        }, s.prototype.layoutPosition = function() {
            var e = this.layout.size,
                t = this.layout.options,
                i = {},
                o = t.isOriginLeft ? "paddingLeft" : "paddingRight",
                n = t.isOriginLeft ? "left" : "right",
                a = t.isOriginLeft ? "right" : "left",
                s = this.position.x + e[o];
            i[n] = this.getXValue(s), i[a] = "";
            var r = t.isOriginTop ? "paddingTop" : "paddingBottom",
                l = t.isOriginTop ? "top" : "bottom",
                d = t.isOriginTop ? "bottom" : "top",
                u = this.position.y + e[r];
            i[l] = this.getYValue(u), i[d] = "", this.css(i), this.emitEvent("layout", [this])
        }, s.prototype.getXValue = function(e) {
            var t = this.layout.options;
            return t.percentPosition && !t.isHorizontal ? e / this.layout.size.width * 100 + "%" : e + "px"
        }, s.prototype.getYValue = function(e) {
            var t = this.layout.options;
            return t.percentPosition && t.isHorizontal ? e / this.layout.size.height * 100 + "%" : e + "px"
        }, s.prototype._transitionTo = function(e, t) {
            this.getPosition();
            var i = this.position.x,
                o = this.position.y,
                n = parseInt(e, 10),
                a = parseInt(t, 10),
                s = n === this.position.x && a === this.position.y;
            if (this.setPosition(e, t), s && !this.isTransitioning) return void this.layoutPosition();
            var r = e - i,
                l = t - o,
                d = {};
            d.transform = this.getTranslate(r, l), this.transition({
                to: d,
                onTransitionEnd: {
                    transform: this.layoutPosition
                },
                isCleaning: !0
            })
        }, s.prototype.getTranslate = function(e, t) {
            var i = this.layout.options;
            return e = i.isOriginLeft ? e : -e, t = i.isOriginTop ? t : -t, e = this.getXValue(e), t = this.getYValue(t), m ? "translate3d(" + e + ", " + t + ", 0)" : "translate(" + e + ", " + t + ")"
        }, s.prototype.goTo = function(e, t) {
            this.setPosition(e, t), this.layoutPosition()
        }, s.prototype.moveTo = p ? s.prototype._transitionTo : s.prototype.goTo, s.prototype.setPosition = function(e, t) {
            this.position.x = parseInt(e, 10), this.position.y = parseInt(t, 10)
        }, s.prototype._nonTransition = function(e) {
            this.css(e.to), e.isCleaning && this._removeStyles(e.to);
            for (var t in e.onTransitionEnd) e.onTransitionEnd[t].call(this)
        }, s.prototype._transition = function(e) {
            if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(e);
            var t = this._transn;
            for (var i in e.onTransitionEnd) t.onEnd[i] = e.onTransitionEnd[i];
            for (i in e.to) t.ingProperties[i] = !0, e.isCleaning && (t.clean[i] = !0);
            if (e.from) {
                this.css(e.from);
                var o = this.element.offsetHeight;
                o = null
            }
            this.enableTransition(e.to), this.css(e.to), this.isTransitioning = !0
        };
        var v = "opacity," + r(y.transform || "transform");
        s.prototype.enableTransition = function() {
            this.isTransitioning || (this.css({
                transitionProperty: v,
                transitionDuration: this.layout.options.transitionDuration
            }), this.element.addEventListener(h, this, !1))
        }, s.prototype.transition = s.prototype[u ? "_transition" : "_nonTransition"], s.prototype.onwebkitTransitionEnd = function(e) {
            this.ontransitionend(e)
        }, s.prototype.onotransitionend = function(e) {
            this.ontransitionend(e)
        };
        var x = {
            "-webkit-transform": "transform",
            "-moz-transform": "transform",
            "-o-transform": "transform"
        };
        s.prototype.ontransitionend = function(e) {
            if (e.target === this.element) {
                var t = this._transn,
                    i = x[e.propertyName] || e.propertyName;
                if (delete t.ingProperties[i], a(t.ingProperties) && this.disableTransition(), i in t.clean && (this.element.style[e.propertyName] = "", delete t.clean[i]), i in t.onEnd) {
                    var o = t.onEnd[i];
                    o.call(this), delete t.onEnd[i]
                }
                this.emitEvent("transitionEnd", [this])
            }
        }, s.prototype.disableTransition = function() {
            this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1
        }, s.prototype._removeStyles = function(e) {
            var t = {};
            for (var i in e) t[i] = "";
            this.css(t)
        };
        var g = {
            transitionProperty: "",
            transitionDuration: ""
        };
        return s.prototype.removeTransitionStyles = function() {
            this.css(g)
        }, s.prototype.removeElem = function() {
            this.element.parentNode.removeChild(this.element), this.css({
                display: ""
            }), this.emitEvent("remove", [this])
        }, s.prototype.remove = function() {
            if (!u || !parseFloat(this.layout.options.transitionDuration)) return void this.removeElem();
            var e = this;
            this.once("transitionEnd", function() {
                e.removeElem()
            }), this.hide()
        }, s.prototype.reveal = function() {
            delete this.isHidden, this.css({
                display: ""
            });
            var e = this.layout.options,
                t = {},
                i = this.getHideRevealTransitionEndProperty("visibleStyle");
            t[i] = this.onRevealTransitionEnd, this.transition({
                from: e.hiddenStyle,
                to: e.visibleStyle,
                isCleaning: !0,
                onTransitionEnd: t
            })
        }, s.prototype.onRevealTransitionEnd = function() {
            this.isHidden || this.emitEvent("reveal")
        }, s.prototype.getHideRevealTransitionEndProperty = function(e) {
            var t = this.layout.options[e];
            if (t.opacity) return "opacity";
            for (var i in t) return i
        }, s.prototype.hide = function() {
            this.isHidden = !0, this.css({
                display: ""
            });
            var e = this.layout.options,
                t = {},
                i = this.getHideRevealTransitionEndProperty("hiddenStyle");
            t[i] = this.onHideTransitionEnd, this.transition({
                from: e.visibleStyle,
                to: e.hiddenStyle,
                isCleaning: !0,
                onTransitionEnd: t
            })
        }, s.prototype.onHideTransitionEnd = function() {
            this.isHidden && (this.css({
                display: "none"
            }), this.emitEvent("hide"))
        }, s.prototype.destroy = function() {
            this.css({
                position: "",
                left: "",
                right: "",
                top: "",
                bottom: "",
                transition: "",
                transform: ""
            })
        }, s
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("outlayer/outlayer", ["eventie/eventie", "eventEmitter/EventEmitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, o, n, a, s) {
            return t(e, i, o, n, a, s)
        }) : "object" == typeof exports ? module.exports = t(e, require("eventie"), require("wolfy87-eventemitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : e.Outlayer = t(e, e.eventie, e.EventEmitter, e.getSize, e.fizzyUIUtils, e.Outlayer.Item)
    }(window, function(e, t, i, o, n, a) {
        function s(e, t) {
            var i = n.getQueryElement(e);
            if (!i) return void(r && r.error("Bad element for " + this.constructor.namespace + ": " + (i || e)));
            this.element = i, l && (this.$element = l(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(t);
            var o = ++u;
            this.element.outlayerGUID = o, c[o] = this, this._create(), this.options.isInitLayout && this.layout()
        }
        var r = e.console,
            l = e.jQuery,
            d = function() {},
            u = 0,
            c = {};
        return s.namespace = "outlayer", s.Item = a, s.defaults = {
            containerStyle: {
                position: "relative"
            },
            isInitLayout: !0,
            isOriginLeft: !0,
            isOriginTop: !0,
            isResizeBound: !0,
            isResizingContainer: !0,
            transitionDuration: "0.4s",
            hiddenStyle: {
                opacity: 0,
                transform: "scale(0.001)"
            },
            visibleStyle: {
                opacity: 1,
                transform: "scale(1)"
            }
        }, n.extend(s.prototype, i.prototype), s.prototype.option = function(e) {
            n.extend(this.options, e)
        }, s.prototype._create = function() {
            this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), this.options.isResizeBound && this.bindResize()
        }, s.prototype.reloadItems = function() {
            this.items = this._itemize(this.element.children)
        }, s.prototype._itemize = function(e) {
            for (var t = this._filterFindItemElements(e), i = this.constructor.Item, o = [], n = 0, a = t.length; a > n; n++) {
                var s = t[n],
                    r = new i(s, this);
                o.push(r)
            }
            return o
        }, s.prototype._filterFindItemElements = function(e) {
            return n.filterFindElements(e, this.options.itemSelector)
        }, s.prototype.getItemElements = function() {
            for (var e = [], t = 0, i = this.items.length; i > t; t++) e.push(this.items[t].element);
            return e
        }, s.prototype.layout = function() {
            this._resetLayout(), this._manageStamps();
            var e = void 0 !== this.options.isLayoutInstant ? this.options.isLayoutInstant : !this._isLayoutInited;
            this.layoutItems(this.items, e), this._isLayoutInited = !0
        }, s.prototype._init = s.prototype.layout, s.prototype._resetLayout = function() {
            this.getSize()
        }, s.prototype.getSize = function() {
            this.size = o(this.element)
        }, s.prototype._getMeasurement = function(e, t) {
            var i, a = this.options[e];
            a ? ("string" == typeof a ? i = this.element.querySelector(a) : n.isElement(a) && (i = a), this[e] = i ? o(i)[t] : a) : this[e] = 0
        }, s.prototype.layoutItems = function(e, t) {
            e = this._getItemsForLayout(e), this._layoutItems(e, t), this._postLayout()
        }, s.prototype._getItemsForLayout = function(e) {
            for (var t = [], i = 0, o = e.length; o > i; i++) {
                var n = e[i];
                n.isIgnored || t.push(n)
            }
            return t
        }, s.prototype._layoutItems = function(e, t) {
            if (this._emitCompleteOnItems("layout", e), e && e.length) {
                for (var i = [], o = 0, n = e.length; n > o; o++) {
                    var a = e[o],
                        s = this._getItemLayoutPosition(a);
                    s.item = a, s.isInstant = t || a.isLayoutInstant, i.push(s)
                }
                this._processLayoutQueue(i)
            }
        }, s.prototype._getItemLayoutPosition = function() {
            return {
                x: 0,
                y: 0
            }
        }, s.prototype._processLayoutQueue = function(e) {
            for (var t = 0, i = e.length; i > t; t++) {
                var o = e[t];
                this._positionItem(o.item, o.x, o.y, o.isInstant)
            }
        }, s.prototype._positionItem = function(e, t, i, o) {
            o ? e.goTo(t, i) : e.moveTo(t, i)
        }, s.prototype._postLayout = function() {
            this.resizeContainer()
        }, s.prototype.resizeContainer = function() {
            if (this.options.isResizingContainer) {
                var e = this._getContainerSize();
                e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1))
            }
        }, s.prototype._getContainerSize = d, s.prototype._setContainerMeasure = function(e, t) {
            if (void 0 !== e) {
                var i = this.size;
                i.isBorderBox && (e += t ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), e = Math.max(e, 0), this.element.style[t ? "width" : "height"] = e + "px"
            }
        }, s.prototype._emitCompleteOnItems = function(e, t) {
            function i() {
                n.dispatchEvent(e + "Complete", null, [t])
            }

            function o() {
                s++, s === a && i()
            }
            var n = this,
                a = t.length;
            if (!t || !a) return void i();
            for (var s = 0, r = 0, l = t.length; l > r; r++) {
                var d = t[r];
                d.once(e, o)
            }
        }, s.prototype.dispatchEvent = function(e, t, i) {
            var o = t ? [t].concat(i) : i;
            if (this.emitEvent(e, o), l)
                if (this.$element = this.$element || l(this.element), t) {
                    var n = l.Event(t);
                    n.type = e, this.$element.trigger(n, i)
                } else this.$element.trigger(e, i)
        }, s.prototype.ignore = function(e) {
            var t = this.getItem(e);
            t && (t.isIgnored = !0)
        }, s.prototype.unignore = function(e) {
            var t = this.getItem(e);
            t && delete t.isIgnored
        }, s.prototype.stamp = function(e) {
            if (e = this._find(e)) {
                this.stamps = this.stamps.concat(e);
                for (var t = 0, i = e.length; i > t; t++) {
                    var o = e[t];
                    this.ignore(o)
                }
            }
        }, s.prototype.unstamp = function(e) {
            if (e = this._find(e))
                for (var t = 0, i = e.length; i > t; t++) {
                    var o = e[t];
                    n.removeFrom(this.stamps, o), this.unignore(o)
                }
        }, s.prototype._find = function(e) {
            return e ? ("string" == typeof e && (e = this.element.querySelectorAll(e)), e = n.makeArray(e)) : void 0
        }, s.prototype._manageStamps = function() {
            if (this.stamps && this.stamps.length) {
                this._getBoundingRect();
                for (var e = 0, t = this.stamps.length; t > e; e++) {
                    var i = this.stamps[e];
                    this._manageStamp(i)
                }
            }
        }, s.prototype._getBoundingRect = function() {
            var e = this.element.getBoundingClientRect(),
                t = this.size;
            this._boundingRect = {
                left: e.left + t.paddingLeft + t.borderLeftWidth,
                top: e.top + t.paddingTop + t.borderTopWidth,
                right: e.right - (t.paddingRight + t.borderRightWidth),
                bottom: e.bottom - (t.paddingBottom + t.borderBottomWidth)
            }
        }, s.prototype._manageStamp = d, s.prototype._getElementOffset = function(e) {
            var t = e.getBoundingClientRect(),
                i = this._boundingRect,
                n = o(e),
                a = {
                    left: t.left - i.left - n.marginLeft,
                    top: t.top - i.top - n.marginTop,
                    right: i.right - t.right - n.marginRight,
                    bottom: i.bottom - t.bottom - n.marginBottom
                };
            return a
        }, s.prototype.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, s.prototype.bindResize = function() {
            this.isResizeBound || (t.bind(e, "resize", this), this.isResizeBound = !0)
        }, s.prototype.unbindResize = function() {
            this.isResizeBound && t.unbind(e, "resize", this), this.isResizeBound = !1
        }, s.prototype.onresize = function() {
            function e() {
                t.resize(), delete t.resizeTimeout
            }
            this.resizeTimeout && clearTimeout(this.resizeTimeout);
            var t = this;
            this.resizeTimeout = setTimeout(e, 100)
        }, s.prototype.resize = function() {
            this.isResizeBound && this.needsResizeLayout() && this.layout()
        }, s.prototype.needsResizeLayout = function() {
            var e = o(this.element),
                t = this.size && e;
            return t && e.innerWidth !== this.size.innerWidth
        }, s.prototype.addItems = function(e) {
            var t = this._itemize(e);
            return t.length && (this.items = this.items.concat(t)), t
        }, s.prototype.appended = function(e) {
            var t = this.addItems(e);
            t.length && (this.layoutItems(t, !0), this.reveal(t))
        }, s.prototype.prepended = function(e) {
            var t = this._itemize(e);
            if (t.length) {
                var i = this.items.slice(0);
                this.items = t.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(t, !0), this.reveal(t), this.layoutItems(i)
            }
        }, s.prototype.reveal = function(e) {
            this._emitCompleteOnItems("reveal", e);
            for (var t = e && e.length, i = 0; t && t > i; i++) {
                var o = e[i];
                o.reveal()
            }
        }, s.prototype.hide = function(e) {
            this._emitCompleteOnItems("hide", e);
            for (var t = e && e.length, i = 0; t && t > i; i++) {
                var o = e[i];
                o.hide()
            }
        }, s.prototype.revealItemElements = function(e) {
            var t = this.getItems(e);
            this.reveal(t)
        }, s.prototype.hideItemElements = function(e) {
            var t = this.getItems(e);
            this.hide(t)
        }, s.prototype.getItem = function(e) {
            for (var t = 0, i = this.items.length; i > t; t++) {
                var o = this.items[t];
                if (o.element === e) return o
            }
        }, s.prototype.getItems = function(e) {
            e = n.makeArray(e);
            for (var t = [], i = 0, o = e.length; o > i; i++) {
                var a = e[i],
                    s = this.getItem(a);
                s && t.push(s)
            }
            return t
        }, s.prototype.remove = function(e) {
            var t = this.getItems(e);
            if (this._emitCompleteOnItems("remove", t), t && t.length)
                for (var i = 0, o = t.length; o > i; i++) {
                    var a = t[i];
                    a.remove(), n.removeFrom(this.items, a)
                }
        }, s.prototype.destroy = function() {
            var e = this.element.style;
            e.height = "", e.position = "", e.width = "";
            for (var t = 0, i = this.items.length; i > t; t++) {
                var o = this.items[t];
                o.destroy()
            }
            this.unbindResize();
            var n = this.element.outlayerGUID;
            delete c[n], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace)
        }, s.data = function(e) {
            e = n.getQueryElement(e);
            var t = e && e.outlayerGUID;
            return t && c[t]
        }, s.create = function(e, t) {
            function i() {
                s.apply(this, arguments)
            }
            return Object.create ? i.prototype = Object.create(s.prototype) : n.extend(i.prototype, s.prototype), i.prototype.constructor = i, i.defaults = n.extend({}, s.defaults), n.extend(i.defaults, t), i.prototype.settings = {}, i.namespace = e, i.data = s.data, i.Item = function() {
                a.apply(this, arguments)
            }, i.Item.prototype = new a, n.htmlInit(i, e), l && l.bridget && l.bridget(e, i), i
        }, s.Item = a, s
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size", "fizzy-ui-utils/utils"], t) : "object" == typeof exports ? module.exports = t(require("outlayer"), require("get-size"), require("fizzy-ui-utils")) : e.Masonry = t(e.Outlayer, e.getSize, e.fizzyUIUtils)
    }(window, function(e, t, i) {
        var o = e.create("masonry");
        return o.prototype._resetLayout = function() {
            this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns();
            var e = this.cols;
            for (this.colYs = []; e--;) this.colYs.push(0);
            this.maxY = 0
        }, o.prototype.measureColumns = function() {
            if (this.getContainerWidth(), !this.columnWidth) {
                var e = this.items[0],
                    i = e && e.element;
                this.columnWidth = i && t(i).outerWidth || this.containerWidth
            }
            var o = this.columnWidth += this.gutter,
                n = this.containerWidth + this.gutter,
                a = n / o,
                s = o - n % o,
                r = s && 1 > s ? "round" : "floor";
            a = Math[r](a), this.cols = Math.max(a, 1)
        }, o.prototype.getContainerWidth = function() {
            var e = this.options.isFitWidth ? this.element.parentNode : this.element,
                i = t(e);
            this.containerWidth = i && i.innerWidth
        }, o.prototype._getItemLayoutPosition = function(e) {
            e.getSize();
            var t = e.size.outerWidth % this.columnWidth,
                o = t && 1 > t ? "round" : "ceil",
                n = Math[o](e.size.outerWidth / this.columnWidth);
            n = Math.min(n, this.cols);
            for (var a = this._getColGroup(n), s = Math.min.apply(Math, a), r = i.indexOf(a, s), l = {
                    x: this.columnWidth * r,
                    y: s
                }, d = s + e.size.outerHeight, u = this.cols + 1 - a.length, c = 0; u > c; c++) this.colYs[r + c] = d;
            return l
        }, o.prototype._getColGroup = function(e) {
            if (2 > e) return this.colYs;
            for (var t = [], i = this.cols + 1 - e, o = 0; i > o; o++) {
                var n = this.colYs.slice(o, o + e);
                t[o] = Math.max.apply(Math, n)
            }
            return t
        }, o.prototype._manageStamp = function(e) {
            var i = t(e),
                o = this._getElementOffset(e),
                n = this.options.isOriginLeft ? o.left : o.right,
                a = n + i.outerWidth,
                s = Math.floor(n / this.columnWidth);
            s = Math.max(0, s);
            var r = Math.floor(a / this.columnWidth);
            r -= a % this.columnWidth ? 0 : 1, r = Math.min(this.cols - 1, r);
            for (var l = (this.options.isOriginTop ? o.top : o.bottom) + i.outerHeight, d = s; r >= d; d++) this.colYs[d] = Math.max(l, this.colYs[d])
        }, o.prototype._getContainerSize = function() {
            this.maxY = Math.max.apply(Math, this.colYs);
            var e = {
                height: this.maxY
            };
            return this.options.isFitWidth && (e.width = this._getContainerFitWidth()), e
        }, o.prototype._getContainerFitWidth = function() {
            for (var e = 0, t = this.cols; --t && 0 === this.colYs[t];) e++;
            return (this.cols - e) * this.columnWidth - this.gutter
        }, o.prototype.needsResizeLayout = function() {
            var e = this.containerWidth;
            return this.getContainerWidth(), e !== this.containerWidth
        }, o
    }),
    function(e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
    }(function(e) {
        var t, i, o, n, a, s, r = "Close",
            l = "BeforeClose",
            d = "AfterClose",
            u = "BeforeAppend",
            c = "MarkupParse",
            p = "Open",
            m = "Change",
            h = "mfp",
            f = "." + h,
            y = "mfp-ready",
            v = "mfp-removing",
            x = "mfp-prevent-close",
            g = function() {},
            b = !!window.jQuery,
            _ = e(window),
            w = function(e, i) {
                t.ev.on(h + e + f, i)
            },
            C = function(t, i, o, n) {
                var a = document.createElement("div");
                return a.className = "mfp-" + t, o && (a.innerHTML = o), n ? i && i.appendChild(a) : (a = e(a), i && a.appendTo(i)), a
            },
            k = function(i, o) {
                t.ev.triggerHandler(h + i, o), t.st.callbacks && (i = i.charAt(0).toLowerCase() + i.slice(1), t.st.callbacks[i] && t.st.callbacks[i].apply(t, e.isArray(o) ? o : [o]))
            },
            T = function(i) {
                return i === s && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)), s = i), t.currTemplate.closeBtn
            },
            I = function() {
                e.magnificPopup.instance || (t = new g, t.init(), e.magnificPopup.instance = t)
            },
            L = function() {
                var e = document.createElement("p").style,
                    t = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== e.transition) return !0;
                for (; t.length;)
                    if (t.pop() + "Transition" in e) return !0;
                return !1
            };
        g.prototype = {
            constructor: g,
            init: function() {
                var i = navigator.appVersion;
                t.isIE7 = -1 !== i.indexOf("MSIE 7."), t.isIE8 = -1 !== i.indexOf("MSIE 8."), t.isLowIE = t.isIE7 || t.isIE8, t.isAndroid = /android/gi.test(i), t.isIOS = /iphone|ipad|ipod/gi.test(i), t.supportsTransition = L(), t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), o = e(document), t.popupsCache = {}
            },
            open: function(i) {
                var n;
                if (i.isObj === !1) {
                    t.items = i.items.toArray(), t.index = 0;
                    var s, r = i.items;
                    for (n = 0; n < r.length; n++)
                        if (s = r[n], s.parsed && (s = s.el[0]), s === i.el[0]) {
                            t.index = n;
                            break
                        }
                } else t.items = e.isArray(i.items) ? i.items : [i.items], t.index = i.index || 0;
                if (t.isOpen) return void t.updateItemHTML();
                t.types = [], a = "", i.mainEl && i.mainEl.length ? t.ev = i.mainEl.eq(0) : t.ev = o, i.key ? (t.popupsCache[i.key] || (t.popupsCache[i.key] = {}), t.currTemplate = t.popupsCache[i.key]) : t.currTemplate = {}, t.st = e.extend(!0, {}, e.magnificPopup.defaults, i), t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos, t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay || (t.bgOverlay = C("bg").on("click" + f, function() {
                    t.close()
                }), t.wrap = C("wrap").attr("tabindex", -1).on("click" + f, function(e) {
                    t._checkIfClose(e.target) && t.close()
                }), t.container = C("container", t.wrap)), t.contentContainer = C("content"), t.st.preloader && (t.preloader = C("preloader", t.container, t.st.tLoading));
                var l = e.magnificPopup.modules;
                for (n = 0; n < l.length; n++) {
                    var d = l[n];
                    d = d.charAt(0).toUpperCase() + d.slice(1), t["init" + d].call(t)
                }
                k("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (w(c, function(e, t, i, o) {
                    i.close_replaceWith = T(o.type)
                }), a += " mfp-close-btn-in") : t.wrap.append(T())), t.st.alignTop && (a += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({
                    overflow: t.st.overflowY,
                    overflowX: "hidden",
                    overflowY: t.st.overflowY
                }) : t.wrap.css({
                    top: _.scrollTop(),
                    position: "absolute"
                }), (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
                    height: o.height(),
                    position: "absolute"
                }), t.st.enableEscapeKey && o.on("keyup" + f, function(e) {
                    27 === e.keyCode && t.close()
                }), _.on("resize" + f, function() {
                    t.updateSize()
                }), t.st.closeOnContentClick || (a += " mfp-auto-cursor"), a && t.wrap.addClass(a);
                var u = t.wH = _.height(),
                    m = {};
                if (t.fixedContentPos && t._hasScrollBar(u)) {
                    var h = t._getScrollbarSize();
                    h && (m.marginRight = h)
                }
                t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : m.overflow = "hidden");
                var v = t.st.mainClass;
                return t.isIE7 && (v += " mfp-ie7"), v && t._addClassToMFP(v), t.updateItemHTML(), k("BuildControls"), e("html").css(m), t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || e(document.body)), t._lastFocusedEl = document.activeElement, setTimeout(function() {
                    t.content ? (t._addClassToMFP(y), t._setFocus()) : t.bgOverlay.addClass(y), o.on("focusin" + f, t._onFocusIn)
                }, 16), t.isOpen = !0, t.updateSize(u), k(p), i
            },
            close: function() {
                t.isOpen && (k(l), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(v), setTimeout(function() {
                    t._close()
                }, t.st.removalDelay)) : t._close())
            },
            _close: function() {
                k(r);
                var i = v + " " + y + " ";
                if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (i += t.st.mainClass + " "), t._removeClassFromMFP(i), t.fixedContentPos) {
                    var n = {
                        marginRight: ""
                    };
                    t.isIE7 ? e("body, html").css("overflow", "") : n.overflow = "", e("html").css(n)
                }
                o.off("keyup" + f + " focusin" + f), t.ev.off(f), t.wrap.attr("class", "mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"), t.container.attr("class", "mfp-container"), !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(), t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t.content = null, t.currTemplate = null, t.prevHeight = 0, k(d)
            },
            updateSize: function(e) {
                if (t.isIOS) {
                    var i = document.documentElement.clientWidth / window.innerWidth,
                        o = window.innerHeight * i;
                    t.wrap.css("height", o), t.wH = o
                } else t.wH = e || _.height();
                t.fixedContentPos || t.wrap.css("height", t.wH), k("Resize")
            },
            updateItemHTML: function() {
                var i = t.items[t.index];
                t.contentContainer.detach(), t.content && t.content.detach(), i.parsed || (i = t.parseEl(t.index));
                var o = i.type;
                if (k("BeforeChange", [t.currItem ? t.currItem.type : "", o]), t.currItem = i, !t.currTemplate[o]) {
                    var a = t.st[o] ? t.st[o].markup : !1;
                    k("FirstMarkupParse", a), a ? t.currTemplate[o] = e(a) : t.currTemplate[o] = !0
                }
                n && n !== i.type && t.container.removeClass("mfp-" + n + "-holder");
                var s = t["get" + o.charAt(0).toUpperCase() + o.slice(1)](i, t.currTemplate[o]);
                t.appendContent(s, o), i.preloaded = !0, k(m, i), n = i.type, t.container.prepend(t.contentContainer), k("AfterChange")
            },
            appendContent: function(e, i) {
                t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[i] === !0 ? t.content.find(".mfp-close").length || t.content.append(T()) : t.content = e : t.content = "", k(u), t.container.addClass("mfp-" + i + "-holder"), t.contentContainer.append(t.content)
            },
            parseEl: function(i) {
                var o, n = t.items[i];
                if (n.tagName ? n = {
                        el: e(n)
                    } : (o = n.type, n = {
                        data: n,
                        src: n.src
                    }), n.el) {
                    for (var a = t.types, s = 0; s < a.length; s++)
                        if (n.el.hasClass("mfp-" + a[s])) {
                            o = a[s];
                            break
                        }
                    n.src = n.el.attr("data-mfp-src"), n.src || (n.src = n.el.attr("href"))
                }
                return n.type = o || t.st.type || "inline", n.index = i, n.parsed = !0, t.items[i] = n, k("ElementParse", n), t.items[i]
            },
            addGroup: function(e, i) {
                var o = function(o) {
                    o.mfpEl = this, t._openClick(o, e, i)
                };
                i || (i = {});
                var n = "click.magnificPopup";
                i.mainEl = e, i.items ? (i.isObj = !0, e.off(n).on(n, o)) : (i.isObj = !1, i.delegate ? e.off(n).on(n, i.delegate, o) : (i.items = e, e.off(n).on(n, o)))
            },
            _openClick: function(i, o, n) {
                var a = void 0 !== n.midClick ? n.midClick : e.magnificPopup.defaults.midClick;
                if (a || 2 !== i.which && !i.ctrlKey && !i.metaKey) {
                    var s = void 0 !== n.disableOn ? n.disableOn : e.magnificPopup.defaults.disableOn;
                    if (s)
                        if (e.isFunction(s)) {
                            if (!s.call(t)) return !0
                        } else if (_.width() < s) return !0;
                    i.type && (i.preventDefault(), t.isOpen && i.stopPropagation()), n.el = e(i.mfpEl), n.delegate && (n.items = o.find(n.delegate)), t.open(n)
                }
            },
            updateStatus: function(e, o) {
                if (t.preloader) {
                    i !== e && t.container.removeClass("mfp-s-" + i), o || "loading" !== e || (o = t.st.tLoading);
                    var n = {
                        status: e,
                        text: o
                    };
                    k("UpdateStatus", n), e = n.status, o = n.text, t.preloader.html(o), t.preloader.find("a").on("click", function(e) {
                        e.stopImmediatePropagation()
                    }), t.container.addClass("mfp-s-" + e), i = e
                }
            },
            _checkIfClose: function(i) {
                if (!e(i).hasClass(x)) {
                    var o = t.st.closeOnContentClick,
                        n = t.st.closeOnBgClick;
                    if (o && n) return !0;
                    if (!t.content || e(i).hasClass("mfp-close") || t.preloader && i === t.preloader[0]) return !0;
                    if (i === t.content[0] || e.contains(t.content[0], i)) {
                        if (o) return !0
                    } else if (n && e.contains(document, i)) return !0;
                    return !1
                }
            },
            _addClassToMFP: function(e) {
                t.bgOverlay.addClass(e), t.wrap.addClass(e)
            },
            _removeClassFromMFP: function(e) {
                this.bgOverlay.removeClass(e), t.wrap.removeClass(e)
            },
            _hasScrollBar: function(e) {
                return (t.isIE7 ? o.height() : document.body.scrollHeight) > (e || _.height())
            },
            _setFocus: function() {
                (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
            },
            _onFocusIn: function(i) {
                return i.target === t.wrap[0] || e.contains(t.wrap[0], i.target) ? void 0 : (t._setFocus(), !1)
            },
            _parseMarkup: function(t, i, o) {
                var n;
                o.data && (i = e.extend(o.data, i)), k(c, [t, i, o]), e.each(i, function(e, i) {
                    if (void 0 === i || i === !1) return !0;
                    if (n = e.split("_"), n.length > 1) {
                        var o = t.find(f + "-" + n[0]);
                        if (o.length > 0) {
                            var a = n[1];
                            "replaceWith" === a ? o[0] !== i[0] && o.replaceWith(i) : "img" === a ? o.is("img") ? o.attr("src", i) : o.replaceWith('<img src="' + i + '" class="' + o.attr("class") + '" />') : o.attr(n[1], i)
                        }
                    } else t.find(f + "-" + e).html(i)
                })
            },
            _getScrollbarSize: function() {
                if (void 0 === t.scrollbarSize) {
                    var e = document.createElement("div");
                    e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e)
                }
                return t.scrollbarSize
            }
        }, e.magnificPopup = {
            instance: null,
            proto: g.prototype,
            modules: [],
            open: function(t, i) {
                return I(), t = t ? e.extend(!0, {}, t) : {}, t.isObj = !0, t.index = i || 0, this.instance.open(t)
            },
            close: function() {
                return e.magnificPopup.instance && e.magnificPopup.instance.close()
            },
            registerModule: function(t, i) {
                i.options && (e.magnificPopup.defaults[t] = i.options), e.extend(this.proto, i.proto), this.modules.push(t)
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading..."
            }
        }, e.fn.magnificPopup = function(i) {
            I();
            var o = e(this);
            if ("string" == typeof i)
                if ("open" === i) {
                    var n, a = b ? o.data("magnificPopup") : o[0].magnificPopup,
                        s = parseInt(arguments[1], 10) || 0;
                    a.items ? n = a.items[s] : (n = o, a.delegate && (n = n.find(a.delegate)), n = n.eq(s)), t._openClick({
                        mfpEl: n
                    }, o, a)
                } else t.isOpen && t[i].apply(t, Array.prototype.slice.call(arguments, 1));
            else i = e.extend(!0, {}, i), b ? o.data("magnificPopup", i) : o[0].magnificPopup = i, t.addGroup(o, i);
            return o
        };
        var E, O = function() {
            return void 0 === E && (E = void 0 !== document.createElement("p").style.MozTransform), E
        };
        e.magnificPopup.registerModule("zoom", {
            options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function(e) {
                    return e.is("img") ? e : e.find("img")
                }
            },
            proto: {
                initZoom: function() {
                    var e, i = t.st.zoom,
                        o = ".zoom";
                    if (i.enabled && t.supportsTransition) {
                        var n, a, s = i.duration,
                            d = function(e) {
                                var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                    o = "all " + i.duration / 1e3 + "s " + i.easing,
                                    n = {
                                        position: "fixed",
                                        zIndex: 9999,
                                        left: 0,
                                        top: 0,
                                        "-webkit-backface-visibility": "hidden"
                                    },
                                    a = "transition";
                                return n["-webkit-" + a] = n["-moz-" + a] = n["-o-" + a] = n[a] = o, t.css(n), t
                            },
                            u = function() {
                                t.content.css("visibility", "visible")
                            };
                        w("BuildControls" + o, function() {
                            if (t._allowZoom()) {
                                if (clearTimeout(n), t.content.css("visibility", "hidden"), e = t._getItemToZoom(), !e) return void u();
                                a = d(e), a.css(t._getOffset()), t.wrap.append(a), n = setTimeout(function() {
                                    a.css(t._getOffset(!0)), n = setTimeout(function() {
                                        u(), setTimeout(function() {
                                            a.remove(), e = a = null, k("ZoomAnimationEnded")
                                        }, 16)
                                    }, s)
                                }, 16)
                            }
                        }), w(l + o, function() {
                            if (t._allowZoom()) {
                                if (clearTimeout(n), t.st.removalDelay = s, !e) {
                                    if (e = t._getItemToZoom(), !e) return;
                                    a = d(e)
                                }
                                a.css(t._getOffset(!0)), t.wrap.append(a), t.content.css("visibility", "hidden"), setTimeout(function() {
                                    a.css(t._getOffset())
                                }, 16)
                            }
                        }), w(r + o, function() {
                            t._allowZoom() && (u(), a && a.remove(), e = null)
                        })
                    }
                },
                _allowZoom: function() {
                    return "image" === t.currItem.type
                },
                _getItemToZoom: function() {
                    return t.currItem.hasSize ? t.currItem.img : !1
                },
                _getOffset: function(i) {
                    var o;
                    o = i ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
                    var n = o.offset(),
                        a = parseInt(o.css("padding-top"), 10),
                        s = parseInt(o.css("padding-bottom"), 10);
                    n.top -= e(window).scrollTop() - a;
                    var r = {
                        width: o.width(),
                        height: (b ? o.innerHeight() : o[0].offsetHeight) - s - a
                    };
                    return O() ? r["-moz-transform"] = r.transform = "translate(" + n.left + "px," + n.top + "px)" : (r.left = n.left, r.top = n.top), r
                }
            }
        });
        var S = "iframe",
            P = "//about:blank",
            R = function(e) {
                if (t.currTemplate[S]) {
                    var i = t.currTemplate[S].find("iframe");
                    i.length && (e || (i[0].src = P), t.isIE8 && i.css("display", e ? "block" : "none"))
                }
            };
        e.magnificPopup.registerModule(S, {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: {
                        index: "youtube.com",
                        id: "v=",
                        src: "//www.youtube.com/embed/%id%?autoplay=1"
                    },
                    vimeo: {
                        index: "vimeo.com/",
                        id: "/",
                        src: "//player.vimeo.com/video/%id%?autoplay=1"
                    },
                    gmaps: {
                        index: "//maps.google.",
                        src: "%id%&output=embed"
                    }
                }
            },
            proto: {
                initIframe: function() {
                    t.types.push(S), w("BeforeChange", function(e, t, i) {
                        t !== i && (t === S ? R() : i === S && R(!0))
                    }), w(r + "." + S, function() {
                        R()
                    })
                },
                getIframe: function(i, o) {
                    var n = i.src,
                        a = t.st.iframe;
                    e.each(a.patterns, function() {
                        return n.indexOf(this.index) > -1 ? (this.id && (n = "string" == typeof this.id ? n.substr(n.lastIndexOf(this.id) + this.id.length, n.length) : this.id.call(this, n)), n = this.src.replace("%id%", n), !1) : void 0
                    });
                    var s = {};
                    return a.srcAction && (s[a.srcAction] = n), t._parseMarkup(o, s, i), t.updateStatus("ready"), o
                }
            }
        });
        var M = function(e) {
                var i = t.items.length;
                return e > i - 1 ? e - i : 0 > e ? i + e : e
            },
            D = function(e, t, i) {
                return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i)
            };
        e.magnificPopup.registerModule("gallery", {
                options: {
                    enabled: !1,
                    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                    preload: [0, 2],
                    navigateByImgClick: !0,
                    arrows: !0,
                    tPrev: "Previous (Left arrow key)",
                    tNext: "Next (Right arrow key)",
                    tCounter: "%curr% of %total%"
                },
                proto: {
                    initGallery: function() {
                        var i = t.st.gallery,
                            n = ".mfp-gallery",
                            s = Boolean(e.fn.mfpFastClick);
                        return t.direction = !0, i && i.enabled ? (a += " mfp-gallery", w(p + n, function() {
                            i.navigateByImgClick && t.wrap.on("click" + n, ".mfp-img", function() {
                                return t.items.length > 1 ? (t.next(), !1) : void 0
                            }), o.on("keydown" + n, function(e) {
                                37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
                            })
                        }), w("UpdateStatus" + n, function(e, i) {
                            i.text && (i.text = D(i.text, t.currItem.index, t.items.length))
                        }), w(c + n, function(e, o, n, a) {
                            var s = t.items.length;
                            n.counter = s > 1 ? D(i.tCounter, a.index, s) : ""
                        }), w("BuildControls" + n, function() {
                            if (t.items.length > 1 && i.arrows && !t.arrowLeft) {
                                var o = i.arrowMarkup,
                                    n = t.arrowLeft = e(o.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")).addClass(x),
                                    a = t.arrowRight = e(o.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")).addClass(x),
                                    r = s ? "mfpFastClick" : "click";
                                n[r](function() {
                                    t.prev()
                                }), a[r](function() {
                                    t.next()
                                }), t.isIE7 && (C("b", n[0], !1, !0), C("a", n[0], !1, !0), C("b", a[0], !1, !0), C("a", a[0], !1, !0)), t.container.append(n.add(a))
                            }
                        }), w(m + n, function() {
                            t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout = setTimeout(function() {
                                t.preloadNearbyImages(), t._preloadTimeout = null
                            }, 16)
                        }), void w(r + n, function() {
                            o.off(n), t.wrap.off("click" + n), t.arrowLeft && s && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(), t.arrowRight = t.arrowLeft = null
                        })) : !1
                    },
                    next: function() {
                        t.direction = !0, t.index = M(t.index + 1), t.updateItemHTML()
                    },
                    prev: function() {
                        t.direction = !1, t.index = M(t.index - 1), t.updateItemHTML()
                    },
                    goTo: function(e) {
                        t.direction = e >= t.index, t.index = e, t.updateItemHTML()
                    },
                    preloadNearbyImages: function() {
                        var e, i = t.st.gallery.preload,
                            o = Math.min(i[0], t.items.length),
                            n = Math.min(i[1], t.items.length);
                        for (e = 1; e <= (t.direction ? n : o); e++) t._preloadItem(t.index + e);
                        for (e = 1; e <= (t.direction ? o : n); e++) t._preloadItem(t.index - e)
                    },
                    _preloadItem: function(i) {
                        if (i = M(i), !t.items[i].preloaded) {
                            var o = t.items[i];
                            o.parsed || (o = t.parseEl(i)), k("LazyLoad", o), "image" === o.type && (o.img = e('<img class="mfp-img" />').on("load.mfploader", function() {
                                o.hasSize = !0
                            }).on("error.mfploader", function() {
                                o.hasSize = !0, o.loadError = !0, k("LazyLoadError", o)
                            }).attr("src", o.src)), o.preloaded = !0
                        }
                    }
                }
            }),
            function() {
                var t = 1e3,
                    i = "ontouchstart" in window,
                    o = function() {
                        _.off("touchmove" + a + " touchend" + a)
                    },
                    n = "mfpFastClick",
                    a = "." + n;
                e.fn.mfpFastClick = function(n) {
                    return e(this).each(function() {
                        var s, r = e(this);
                        if (i) {
                            var l, d, u, c, p, m;
                            r.on("touchstart" + a, function(e) {
                                c = !1, m = 1, p = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0], d = p.clientX, u = p.clientY, _.on("touchmove" + a, function(e) {
                                    p = e.originalEvent ? e.originalEvent.touches : e.touches, m = p.length, p = p[0], (Math.abs(p.clientX - d) > 10 || Math.abs(p.clientY - u) > 10) && (c = !0, o())
                                }).on("touchend" + a, function(e) {
                                    o(), c || m > 1 || (s = !0, e.preventDefault(), clearTimeout(l), l = setTimeout(function() {
                                        s = !1
                                    }, t), n())
                                })
                            })
                        }
                        r.on("click" + a, function() {
                            s || n()
                        })
                    })
                }, e.fn.destroyMfpFastClick = function() {
                    e(this).off("touchstart" + a + " click" + a), i && _.off("touchmove" + a + " touchend" + a)
                }
            }(), I()
    }),
    function(e) {
        if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();
        else if ("function" == typeof define && define.amd) define([], e);
        else {
            var t;
            t = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, t.Share = e()
        }
    }(function() {
        function e(e) {
            return "" + e.selector + " .social.bottom," + e.selector + " .social.top{-webkit-transform-origin:0 0;-moz-transform-origin:0 0;-o-transform-origin:0 0}" + e.selector + "{width:92px;height:20px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}" + e.selector + " [class*=entypo-]:before{font-family:entypo,sans-serif}" + e.selector + " label{font-size:16px;cursor:pointer;margin:0;padding:5px 10px;border-radius:5px;background:#a29baa;color:#333;transition:all .3s ease}" + e.selector + " label:hover{opacity:.8}" + e.selector + " label span{text-transform:uppercase;font-size:.9em;font-family:Lato,sans-serif;font-weight:700;-webkit-font-smoothing:antialiased;padding-left:6px}" + e.selector + " .social{opacity:0;transition:all .4s ease;margin-left:-15px;visibility:hidden}" + e.selector + " .social.top{-ms-transform-origin:0 0;transform-origin:0 0;margin-top:-90px}" + e.selector + " .social.bottom{-ms-transform-origin:0 0;transform-origin:0 0;margin-top:5px}" + e.selector + " .social.middle.left," + e.selector + " .social.middle.right{-ms-transform-origin:5% 50%;transform-origin:5% 50%;-webkit-transform-origin:5% 50%;-moz-transform-origin:5% 50%;-o-transform-origin:5% 50%}" + e.selector + " .social.middle{margin-top:-34px}" + e.selector + " .social.middle.right{margin-left:105px}" + e.selector + " .social.networks-1.center," + e.selector + " .social.networks-1.left," + e.selector + " .social.right{margin-left:14px}" + e.selector + " .social.load{transition:none!important}" + e.selector + " .social.networks-1{width:60px}" + e.selector + " .social.networks-1.middle.left{margin-left:-70px}" + e.selector + " .social.networks-1 ul{width:60px}" + e.selector + " .social.networks-2," + e.selector + " .social.networks-2 ul{width:120px}" + e.selector + " .social.networks-2.center{margin-left:-13px}" + e.selector + " .social.networks-2.left{margin-left:-44px}" + e.selector + " .social.networks-2.middle.left{margin-left:-130px}" + e.selector + " .social.networks-3," + e.selector + " .social.networks-3 ul{width:180px}" + e.selector + " .social.networks-3.center{margin-left:-45px}" + e.selector + " .social.networks-3.left{margin-left:-102px}" + e.selector + " .social.networks-3.middle.left{margin-left:-190px}" + e.selector + " .social.networks-4," + e.selector + " .social.networks-4 ul{width:240px}" + e.selector + " .social.networks-4.center{margin-left:-75px}" + e.selector + " .social.networks-4.left{margin-left:162px}" + e.selector + " .social.networks-4.middle.left{margin-left:-250px}" + e.selector + " .social.networks-5," + e.selector + " .social.networks-5 ul{width:300px}" + e.selector + " .social.networks-5.center{margin-left:-105px}" + e.selector + " .social.networks-5.left{margin-left:-225px}" + e.selector + " .social.networks-5.middle.left{margin-left:-320px}" + e.selector + " .social.active{opacity:1;transition:all .4s ease;visibility:visible}" + e.selector + " .social.active.top{-webkit-transform:scale(1)translateY(-10px);-moz-transform:scale(1)translateY(-10px);-o-transform:scale(1)translateY(-10px);-ms-transform:scale(1)translateY(-10px);transform:scale(1)translateY(-10px)}" + e.selector + " .social.active.bottom{-webkit-transform:scale(1)translateY(15px);-moz-transform:scale(1)translateY(15px);-o-transform:scale(1)translateY(15px);-ms-transform:scale(1)translateY(15px);transform:scale(1)translateY(15px)}" + e.selector + " .social.active.middle.right{-webkit-transform:scale(1)translateX(10px);-moz-transform:scale(1)translateX(10px);-o-transform:scale(1)translateX(10px);-ms-transform:scale(1)translateX(10px);transform:scale(1)translateX(10px)}" + e.selector + " .social.active.middle.left{-webkit-transform:scale(1)translateX(-10px);-moz-transform:scale(1)translateX(-10px);-o-transform:scale(1)translateX(-10px);-ms-transform:scale(1)translateX(-10px);transform:scale(1)translateX(-10px)}" + e.selector + " .social ul{position:relative;left:0;right:0;height:46px;color:#fff;margin:auto;padding:0;list-style:none}" + e.selector + " .social ul li{font-size:20px;cursor:pointer;width:60px;margin:0;padding:12px 0;text-align:center;float:left;display:none;height:22px;position:relative;z-index:2;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;transition:all .3s ease}" + e.selector + " .social ul li:hover{color:rgba(0,0,0,.5)}" + e.selector + " .social li[class*=facebook]{background:#3b5998;display:" + e.networks.facebook.display + "}" + e.selector + " .social li[class*=twitter]{background:#6cdfea;display:" + e.networks.twitter.display + "}" + e.selector + " .social li[class*=gplus]{background:#e34429;display:" + e.networks.google_plus.display + "}" + e.selector + " .social li[class*=pinterest]{background:#c5282f;display:" + e.networks.pinterest.display + "}" + e.selector + " .social li[class*=paper-plane]{background:#42c5b0;display:" + e.networks.email.display + "}"
        }
        var t;
        "classList" in document.documentElement || !Object.defineProperty || "undefined" == typeof HTMLElement || Object.defineProperty(HTMLElement.prototype, "classList", {
            get: function() {
                var e, t, i;
                return i = function(e) {
                    return function(i) {
                        var o, n;
                        o = t.className.split(/\s+/), n = o.indexOf(i), e(o, n, i), t.className = o.join(" ")
                    }
                }, t = this, e = {
                    add: i(function(e, t, i) {
                        ~t || e.push(i)
                    }),
                    remove: i(function(e, t) {
                        ~t && e.splice(t, 1)
                    }),
                    toggle: i(function(e, t, i) {
                        ~t ? e.splice(t, 1) : e.push(i)
                    }),
                    contains: function(e) {
                        return !!~t.className.split(/\s+/).indexOf(e)
                    },
                    item: function(e) {
                        return t.className.split(/\s+/)[e] || null
                    }
                }, Object.defineProperty(e, "length", {
                    get: function() {
                        return t.className.split(/\s+/).length
                    }
                }), e
            }
        }), String.prototype.to_rfc3986 = function() {
            var e;
            return e = encodeURIComponent(this), e.replace(/[!'()*]/g, function(e) {
                return "%" + e.charCodeAt(0).toString(16)
            })
        }, t = function() {
            function e() {}
            return e.prototype.extend = function(e, t, i) {
                var o, n;
                for (n in t) o = void 0 !== e[n], o && "object" == typeof t[n] ? this.extend(e[n], t[n], i) : (i || !o) && (e[n] = t[n])
            }, e.prototype.hide = function(e) {
                return e.style.display = "none"
            }, e.prototype.show = function(e) {
                return e.style.display = "block"
            }, e.prototype.has_class = function(e, t) {
                return e.classList.contains(t)
            }, e.prototype.add_class = function(e, t) {
                return e.classList.add(t)
            }, e.prototype.remove_class = function(e, t) {
                return e.classList.remove(t)
            }, e.prototype.is_encoded = function(e) {
                return e = e.to_rfc3986(), decodeURIComponent(e) !== e
            }, e.prototype.encode = function(e) {
                return "undefined" == typeof e || this.is_encoded(e) ? e : e.to_rfc3986()
            }, e.prototype.popup = function(e, t) {
                var i, o, n, a;
                return null == t && (t = {}), o = {
                    width: 500,
                    height: 350
                }, o.top = screen.height / 2 - o.height / 2, o.left = screen.width / 2 - o.width / 2, n = function() {
                    var e;
                    e = [];
                    for (i in t) a = t[i], e.push(i + "=" + this.encode(a));
                    return e
                }.call(this).join("&"), n && (n = "?" + n), window.open(e + n, "targetWindow", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,left=" + o.left + ",top=" + o.top + ",width=" + o.width + ",height=" + o.height)
            }, e
        }();
        var i, o = function(e, t) {
                function i() {
                    this.constructor = e
                }
                for (var o in t) n.call(t, o) && (e[o] = t[o]);
                return i.prototype = t.prototype, e.prototype = new i, e.__super__ = t.prototype, e
            },
            n = {}.hasOwnProperty;
        return i = function(t) {
            function i(e, t) {
                return this.element = e, this.el = {
                    head: document.getElementsByTagName("head")[0],
                    body: document.getElementsByTagName("body")[0]
                }, this.config = {
                    enabled_networks: 0,
                    protocol: -1 === ["http", "https"].indexOf(window.location.href.split(":")[0]) ? "https://" : "//",
                    url: window.location.href,
                    caption: null,
                    title: this.default_title(),
                    image: this.default_image(),
                    description: this.default_description(),
                    ui: {
                        flyout: "top center",
                        button_text: "Share",
                        button_font: !0,
                        icon_font: !0
                    },
                    networks: {
                        google_plus: {
                            enabled: !0,
                            url: null
                        },
                        twitter: {
                            enabled: !0,
                            url: null,
                            description: null
                        },
                        facebook: {
                            enabled: !0,
                            load_sdk: !0,
                            url: null,
                            app_id: null,
                            title: null,
                            caption: null,
                            description: null,
                            image: null
                        },
                        pinterest: {
                            enabled: !0,
                            url: null,
                            image: null,
                            description: null
                        },
                        email: {
                            enabled: !0,
                            title: null,
                            description: null
                        }
                    }
                }, this.setup(this.element, t), this
            }
            return o(i, t), i.prototype.setup = function(e, t) {
                var i, o, n, a, s;
                for (a = document.querySelectorAll(e), this.extend(this.config, t, !0), this.set_global_configuration(), this.normalize_network_configuration(), this.config.ui.icon_font && this.inject_icons(), this.config.ui.button_font && this.inject_fonts(), this.config.networks.facebook.enabled && this.config.networks.facebook.load_sdk && this.inject_facebook_sdk(), o = i = 0, s = a.length; s > i; o = ++i) n = a[o], this.setup_instance(e, o)
            }, i.prototype.setup_instance = function(e, t) {
                var i, o, n, a, s, r, l, d, u;
                for (a = document.querySelectorAll(e)[t], this.hide(a), this.add_class(a, "sharer-" + t), a = document.querySelectorAll(e)[t], this.inject_css(a), this.inject_html(a), this.show(a), s = a.getElementsByTagName("label")[0], o = a.getElementsByClassName("social")[0], d = a.getElementsByTagName("li"), this.add_class(o, "networks-" + this.config.enabled_networks), s.addEventListener("click", function(e) {
                        return function() {
                            return e.event_toggle(o)
                        }
                    }(this)), i = this, u = [], t = n = 0, r = d.length; r > n; t = ++n) l = d[t], u.push(l.addEventListener("click", function() {
                    return i.event_network(a, this), i.event_close(o)
                }));
                return u
            }, i.prototype.event_toggle = function(e) {
                return this.has_class(e, "active") ? this.event_close(e) : this.event_open(e)
            }, i.prototype.event_open = function(e) {
                return this.has_class(e, "load") && this.remove_class(e, "load"), this.add_class(e, "active")
            }, i.prototype.event_close = function(e) {
                return this.remove_class(e, "active")
            }, i.prototype.event_network = function(e, t) {
                var i;
                return i = t.getAttribute("data-network"), this.hook("before", i, e), this["network_" + i](), this.hook("after", i, e)
            }, i.prototype.open = function() {
                return this["public"]("open")
            }, i.prototype.close = function() {
                return this["public"]("close")
            }, i.prototype.toggle = function() {
                return this["public"]("toggle")
            }, i.prototype["public"] = function(e) {
                var t, i, o, n, a, s, r;
                for (s = document.querySelectorAll(this.element), r = [], o = i = 0, a = s.length; a > i; o = ++i) n = s[o], t = n.getElementsByClassName("social")[0], r.push(this["event_" + e](t));
                return r
            }, i.prototype.network_facebook = function() {
                return this.config.networks.facebook.load_sdk ? window.FB ? FB.ui({
                    method: "feed",
                    name: this.config.networks.facebook.title,
                    link: this.config.networks.facebook.url,
                    picture: this.config.networks.facebook.image,
                    caption: this.config.networks.facebook.caption,
                    description: this.config.networks.facebook.description
                }) : console.error("The Facebook JS SDK hasn't loaded yet.") : this.popup("https://www.facebook.com/sharer/sharer.php", {
                    u: this.config.networks.facebook.url
                })
            }, i.prototype.network_twitter = function() {
                return this.popup("https://twitter.com/intent/tweet", {
                    text: this.config.networks.twitter.description,
                    url: this.config.networks.twitter.url
                })
            }, i.prototype.network_google_plus = function() {
                return this.popup("https://plus.google.com/share", {
                    url: this.config.networks.google_plus.url
                })
            }, i.prototype.network_pinterest = function() {
                return this.popup("https://www.pinterest.com/pin/create/button", {
                    url: this.config.networks.pinterest.url,
                    media: this.config.networks.pinterest.image,
                    description: this.config.networks.pinterest.description
                })
            }, i.prototype.network_email = function() {
                return this.popup("mailto:", {
                    subject: this.config.networks.email.title,
                    body: this.config.networks.email.description
                })
            }, i.prototype.inject_icons = function() {}, i.prototype.inject_fonts = function() {}, i.prototype.inject_stylesheet = function(e) {
                var t;
                return this.el.head.querySelector('link[href="' + e + '"]') ? void 0 : (t = document.createElement("link"), t.setAttribute("rel", "stylesheet"), t.setAttribute("href", e), this.el.head.appendChild(t))
            }, i.prototype.inject_css = function(t) {
                var i, o, n, a;
                return n = "." + t.getAttribute("class").split(" ").join("."), this.el.head.querySelector("meta[name='sharer" + n + "']") ? void 0 : (this.config.selector = n, i = e(this.config), a = document.createElement("style"),
                    a.type = "text/css", a.styleSheet ? a.styleSheet.cssText = i : a.appendChild(document.createTextNode(i)), this.el.head.appendChild(a), delete this.config.selector, o = document.createElement("meta"), o.setAttribute("name", "sharer" + n), this.el.head.appendChild(o))
            }, i.prototype.inject_html = function(e) {
                return e.innerHTML = "<label class='entypo-export'><span>" + this.config.ui.button_text + "</span></label><div class='social load " + this.config.ui.flyout + "'><ul><li class='entypo-pinterest' data-network='pinterest'><i class='fa fa-pinterest fa-lg'></i></li><li class='entypo-twitter' data-network='twitter'><i class='fa fa-twitter fa-lg'></i></li><li class='entypo-facebook' data-network='facebook'><i class='fa fa-facebook fa-lg'></i></li><li class='entypo-gplus' data-network='google_plus'><i class='fa fa-google-plus fa-lg'></i></li><li class='entypo-paper-plane' data-network='email'><i class='fa fa-envelope-o fa-lg'></i></li></ul></div>"
            }, i.prototype.inject_facebook_sdk = function() {
                var e, t;
                return window.FB || !this.config.networks.facebook.app_id || this.el.body.querySelector("#fb-root") ? void 0 : (t = document.createElement("script"), t.text = "window.fbAsyncInit=function(){FB.init({appId:'" + this.config.networks.facebook.app_id + "',status:true,xfbml:true})};(function(e,t,n){var r,i=e.getElementsByTagName(t)[0];if(e.getElementById(n)){return}r=e.createElement(t);r.id=n;r.src='" + this.config.protocol + "connect.facebook.net/en_US/all.js';i.parentNode.insertBefore(r,i)})(document,'script','facebook-jssdk')", e = document.createElement("div"), e.id = "fb-root", this.el.body.appendChild(e), this.el.body.appendChild(t))
            }, i.prototype.hook = function(e, t, i) {
                var o, n;
                o = this.config.networks[t][e], "function" == typeof o && (n = o.call(this.config.networks[t], i), void 0 !== n && (n = this.normalize_filter_config_updates(n), this.extend(this.config.networks[t], n, !0), this.normalize_network_configuration()))
            }, i.prototype.default_title = function() {
                var e;
                return (e = document.querySelector('meta[property="og:title"]') || document.querySelector('meta[name="twitter:title"]')) ? e.getAttribute("content") : (e = document.querySelector("title")) ? e.innerText : void 0
            }, i.prototype.default_image = function() {
                var e;
                return (e = document.querySelector('meta[property="og:image"]') || document.querySelector('meta[name="twitter:image"]')) ? e.getAttribute("content") : void 0
            }, i.prototype.default_description = function() {
                var e;
                return (e = document.querySelector('meta[property="og:description"]') || document.querySelector('meta[name="twitter:description"]') || document.querySelector('meta[name="description"]')) ? e.getAttribute("content") : ""
            }, i.prototype.set_global_configuration = function() {
                var e, t, i, o, n, a;
                n = this.config.networks, a = [];
                for (t in n) {
                    o = n[t];
                    for (i in o) null == this.config.networks[t][i] && (this.config.networks[t][i] = this.config[i]);
                    this.config.networks[t].enabled ? (e = "block", this.config.enabled_networks += 1) : e = "none", a.push(this.config.networks[t].display = e)
                }
                return a
            }, i.prototype.normalize_network_configuration = function() {
                return this.config.networks.facebook.app_id || (this.config.networks.facebook.load_sdk = !1), this.is_encoded(this.config.networks.twitter.description) || (this.config.networks.twitter.description = encodeURIComponent(this.config.networks.twitter.description)), "number" == typeof this.config.networks.facebook.app_id ? this.config.networks.facebook.app_id = this.config.networks.facebook.app_id.toString() : void 0
            }, i.prototype.normalize_filter_config_updates = function(e) {
                return this.config.networks.facebook.app_id !== e.app_id && (console.warn("You are unable to change the Facebook app_id after the button has been initialized. Please update your Facebook filters accordingly."), delete e.app_id), this.config.networks.facebook.load_sdk !== e.load_sdk && (console.warn("You are unable to change the Facebook load_sdk option after the button has been initialized. Please update your Facebook filters accordingly."), delete e.app_id), e
            }, i
        }(t)
    });
var youmaxLoggedInUser = {},
    layoutResizeTimer, $youmaxGrid;
! function(e) {
    var t = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxResults;
            null != i && (n = "&pageToken=" + i, a = !0), apiPlaylistVideosURL = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=" + t + "&maxResults=" + l + n + "&key=" + r, e.ajax({
                url: apiPlaylistVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    F(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        o = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.maxResults;
            null != i && (n = "&" + i, a = !0), apiVimeoVideosURL = "https://api.vimeo.com/users/" + t + "/videos?access_token=" + s.vimeoAccessToken + "&per_page=" + r + n, e.ajax({
                url: apiVimeoVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    q(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        n = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.maxResults;
            null != i && (n = "&" + i, a = !0), apiVimeoVideosURL = "https://api.vimeo.com/channels/" + t + "/videos?access_token=" + s.vimeoAccessToken + "&per_page=" + r + n, e.ajax({
                url: apiVimeoVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    q(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        a = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.maxResults;
            null != i && (n = "&" + i, a = !0), apiVimeoVideosURL = "https://api.vimeo.com/groups/" + t + "/videos?access_token=" + s.vimeoAccessToken + "&per_page=" + r + n, e.ajax({
                url: apiVimeoVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    q(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        r = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.maxResults;
            null != i && (n = "&" + i, a = !0), apiVimeoVideosURL = "https://api.vimeo.com/albums/" + t + "/videos?access_token=" + s.vimeoAccessToken + "&per_page=" + r + n, e.ajax({
                url: apiVimeoVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    q(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        l = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxResults;
            null != i && (n = "&pageToken=" + i, a = !0), a ? (apiEventVideosURL = "https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=completed&order=date&channelId=" + t + "&type=video&maxResults=" + l + n + "&key=" + r, e.ajax({
                url: apiEventVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    G(e, o, !1, !0, a)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })) : (eventCache = {
                items: [],
                nextPageToken: "youmax-generated"
            }, eventCacheStatus = [], o.data("eventcache", eventCache), o.data("eventcachestatus", eventCacheStatus), apiEventVideosURL = "https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=live&order=date&channelId=" + t + "&type=video&maxResults=50&key=" + r, e.ajax({
                url: apiEventVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    d(e, o, "live")
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            }), setTimeout(function() {
                apiEventVideosURL = "https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=upcoming&order=date&channelId=" + t + "&type=video&maxResults=50&key=" + r, e.ajax({
                    url: apiEventVideosURL,
                    type: "GET",
                    async: !0,
                    cache: !0,
                    dataType: "jsonp",
                    success: function(e) {
                        d(e, o, "upcoming")
                    },
                    error: function(e) {
                        alert(e)
                    },
                    beforeSend: O
                })
            }, 200), setTimeout(function() {
                -1 != s.loadMode.indexOf("paginate") && (l = 50), apiEventVideosURL = "https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=completed&order=date&channelId=" + t + "&type=video&maxResults=" + l + "&key=" + r, e.ajax({
                    url: apiEventVideosURL,
                    type: "GET",
                    async: !0,
                    cache: !0,
                    dataType: "jsonp",
                    success: function(e) {
                        d(e, o, "completed")
                    },
                    error: function(e) {
                        alert(e)
                    },
                    beforeSend: O
                })
            }, 400))
        },
        d = function(e, t, i) {
            eventCache = t.data("eventcache"), eventCacheStatus = t.data("eventcachestatus");
            var o = t.data("youmax_global_options");
            null != e.items && e.items.length > 0 && (eventCache.items = eventCache.items.concat(e.items)), "completed" == i && (eventCache.nextPageToken = e.nextPageToken), eventCacheStatus.push(i), eventCacheStatus.length >= 3 && -1 != eventCacheStatus.indexOf("live") && -1 != eventCacheStatus.indexOf("upcoming") && -1 != eventCacheStatus.indexOf("completed") && (-1 != o.loadMode.indexOf("paginate") ? (cache = eventCache.items, cacheIndex = -1 - o.maxResults, t.data("cache", cache), t.data("cacheindex", cacheIndex), t.find("#youmax-next-div").data("nextpagetoken", eventCache.nextPageToken), v(t, "next")) : G(eventCache, t, !1, !0)), t.data("eventcache", eventCache), t.data("eventcachestatus", eventCacheStatus)
        },
        u = function(t, i, o, n) {
            var a = i.data("youmax_global_options"),
                s = i.data("youmax_translator_text");
            apiVideoDetailURL = "https://www.googleapis.com/youtube/v3/videos?part=statistics%2Csnippet&id=" + t + "&key=" + a.apiKey, e.ajax({
                url: apiVideoDetailURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(a) {
                    $baseElement = e('<div id="youtube_' + t + '"><div class="youmax-video-list-title">' + a.items[0].snippet.title + '</div><div class="youmax-video-list-date">' + Q(a.items[0].snippet.publishedAt, s) + "</div></div>"), $baseElement.data("description", a.items[0].snippet.description), $baseElement.data("likes", R(a.items[0].statistics.likeCount)), $baseElement.data("views", P(a.items[0].statistics.viewCount)), $baseElement.data("channelid", a.items[0].snippet.channelId), ie($baseElement, o, n, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        c = function(t, i, o, n) {
            var a = i.data("youmax_global_options"),
                s = i.data("youmax_translator_text");
            apiVideoDetailURL = "https://api.vimeo.com/videos/" + t + "?access_token=" + a.vimeoAccessToken, e.ajax({
                url: apiVideoDetailURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(a) {
                    videoDescription = a.description.replace(/"/g, "'"), videoViewCount = a.stats.plays, null == videoViewCount ? videoViewCount = "Private" : videoViewCount = P(videoViewCount), $baseElement = e('<div id="vimeo_' + t + '"><div class="youmax-video-list-title">' + a.name + '</div><div class="youmax-video-list-date">' + Q(a.created_time, s) + "</div></div>"), $baseElement.data("description", videoDescription), $baseElement.data("likes", R(a.metadata.connections.likes.total)), $baseElement.data("comments", R(a.metadata.connections.comments.total)), $baseElement.data("views", P(videoViewCount)), $baseElement.data("channelid", ""), ie($baseElement, o, n, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        p = function(t, i, o) {
            var n = "",
                a = !1,
                s = i.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxComments;
            null != o && (n = "&pageToken=" + o, a = !0), apiVideoCommentsURL = "https://www.googleapis.com/youtube/v3/commentThreads?part=id%2Csnippet&videoId=" + t + n + "&maxResults=" + l + "&key=" + r + "&order=" + s.commentOrder, e.ajax({
                url: apiVideoCommentsURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    A(e, a, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        m = function(t, i, o) {
            var n = "",
                a = !1,
                s = i.data("youmax_global_options"),
                r = (s.apiKey, s.maxComments);
            null != o && (n = "&" + o, a = !0), apiVideoCommentsURL = "https://api.vimeo.com/videos/" + t + "/comments?per_page=" + r + "&access_token=" + s.vimeoAccessToken + "&sort=date" + n, e.ajax({
                url: apiVideoCommentsURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    W(e, a, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        h = function() {
            e.ajaxSetup({
                cache: !0
            }), e.getScript("https://apis.google.com/js/platform.js").done(function(e, t) {}).fail(function(e, t, i) {})
        },
        f = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxResults;
            null != i && (n = "&pageToken=" + i, a = !0), o.data("youmax_last_channel_playlists", "youtube_channel_playlists_" + t), apiChannelPlaylistsURL = "https://www.googleapis.com/youtube/v3/playlists?part=contentDetails,snippet&channelId=" + t + "&maxResults=" + l + n + "&key=" + r, e.ajax({
                url: apiChannelPlaylistsURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    H(e, a, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        y = function(t) {
            var i = t.data("youmax_global_options");
            t.empty(), t.append('<div id="youmax-header"><div id="youmax-header-wrapper"></div></div>'), t.append('<div id="youmax-tabs"></div>'), t.append('<div id="youmax-select-box"><select id="youmax-select"></select></div>'), i.showTopAdSpace && t.append('<div class="youmax-ad-space">' + i.topAdHtml + "</div>"), "popup" != i.displayVideo && t.append('<div id="youmax-encloser"></div>'), t.append('<div id="youmax-showing-title"></div>');
            var o = "";
            "paginate-sides" == i.loadMode && (o = "youmax-small-container"), t.append('<div id="youmax-video-list-div" class="' + o + '"><ul id="tiles"></ul></div>');
            var n = null,
                a = null,
                s = null,
                r = "";
            "small" == i.loadButtonSize && (r = 'class="youmax-small"'), "loadmore" == i.loadMode ? (t.append('<button type="button" id="youmax-load-more-div" ' + r + "></button>"), n = t.find("#youmax-load-more-div")) : "paginate-bottom" == i.loadMode ? (t.append('<div class="youmax-pagination"><div class="youmax-pagination-button-wrapper youmax-left-wrapper"><button type="button" id="youmax-previous-div" ' + r + '></button></div><div class="youmax-pagination-button-wrapper youmax-right-wrapper"><button type="button" id="youmax-next-div" ' + r + "></button></div></div>"), s = t.find("#youmax-next-div"), a = t.find("#youmax-previous-div")) : "paginate-sides" == i.loadMode && (t.append('<div class="youmax-pagination-button-wrapper youmax-left-wrapper youmax-side-nav"><button type="button" id="youmax-previous-div" ' + r + '></button></div><div class="youmax-pagination-button-wrapper youmax-right-wrapper youmax-side-nav"><button type="button" id="youmax-next-div" ' + r + "></button></div>"), s = t.find("#youmax-next-div"), a = t.find("#youmax-previous-div")), Z(t), null != n && (n.data("nextpagetoken", ""), n.click(function() {
                _(t)
            })), null != a && a.click(function() {
                v(t, "previous")
            }), null != s && s.click(function() {
                v(t, "next")
            }), t.find("#youmax-tabs").on("click", ".youmax-tab", function() {
                t.find("#youmax-load-more-div").removeAttr("disabled"), ue(this.id, t)
            }), t.find("#youmax-select").change(function() {
                var i = e(this).find(":selected").val();
                ue(i, t)
            }), "popup" == i.displayVideo ? ($youmaxPlayBox = e("body"), $youmaxPlayBox.off("click", ".youmax-show-button"), $youmaxPlayBox.off("click", ".youmax-add-comment-button")) : $youmaxPlayBox = t, $youmaxPlayBox.on("click", ".youmax-show-button", function() {
                le(this.id, t)
            }), $youmaxPlayBox.on("click", ".youmax-more-button", function() {
                de(t)
            }), e.getScript("https://apis.google.com/js/client:platform.js").done(function(e, i) {
                $youmaxPlayBox.on("click", ".youmax-add-comment-button", function() {
                    g(this, t)
                })
            }).fail(function(e, t, i) {}), t.on("keyup", "#youmax-search-box,#youmax-search-box-header", function(i) {
                var text = jQuery('#youmax-search-box').val();
                if(text == '' || text == null){
                  return void 0 
                }else{
                  return (searchText = "query_" + e(this).val(), ue(searchText, t), !1)
                }
            }), -1 != i.skin.indexOf("clean") ? (t.on("mouseenter", "#tiles li", function() {
                e(this).find(".youmax-duration").show(), e(this).find(".youmax-definition").show(), e(this).find(".youmax-clean-overlay-holder").hide()
            }), t.on("mouseleave", "#tiles li", function() {
                e(this).find(".youmax-duration").hide(), e(this).find(".youmax-definition").hide(), e(this).find(".youmax-clean-overlay-holder").show()
            })) : "thumbnail" != i.displayVideo && (i.playIconType && "default" != i.playIconType ? (t.on("mouseenter", ".youmax-thumbnail-image-wrapper", function() {
                e(this).find(".youmax-play-overlay").addClass("youmax-play-hover")
            }), t.on("mouseleave", ".youmax-thumbnail-image-wrapper", function() {
                e(this).find(".youmax-play-overlay").removeClass("youmax-play-hover")
            })) : (t.on("mouseenter", ".youmax-thumbnail-image-wrapper", function() {
                e(this).find(".youmax-play-overlay").show()
            }), t.on("mouseleave", ".youmax-thumbnail-image-wrapper", function() {
                e(this).find(".youmax-play-overlay").hide()
            }))), t.on("click", "#youmax-back-to-playlists", function() {
                var e = t.data("youmax_last_channel_playlists");
                t.find("#" + e).click()
            }), t.on("click", "#youmax-search-holder-header", function() {
                e(this).find("#youmax-search-box-header").toggle()
            }), t.on("click", "#youmax-search-box-header", function(e) {
                return !1
            }), e(window).resize(function() {
                clearTimeout(layoutResizeTimer), layoutResizeTimer = setTimeout(function() {
                    e("body").find(".youmax").each(function() {
                        $ymaxContainer = e(this), be($ymaxContainer.width(), $ymaxContainer)
                    }), setTimeout(function() {
                        e("body").find(".youmax").each(function() {
                            $ymaxContainer = e(this), ymax_global_options = $ymaxContainer.data("youmax_global_options"), -1 != ymax_global_options.skin.indexOf("trend") && $ymaxContainer.find("#tiles li:first-child").width() < 280 ? $ymaxContainer.find(".youmax-video-list-date").hide() : $ymaxContainer.find(".youmax-video-list-date").show(), $ymaxContainer.find("ul").masonry("layout")
                        })
                    }, i.updateLayoutDelay)
                }, i.updateLayoutDelay)
            }), e(window).on("load", function() {
                setTimeout(function() {
                    e("body").find(".youmax").each(function() {
                        e(this).find("ul").masonry("layout")
                    })
                }, i.updateLayoutDelay)
            })
        },
        v = function(e, t) {
            "previous" == t ? w(e, "previous") : w(e), $youmaxContainerList = e.find("ul#tiles");
            var i = $youmaxContainerList.height();
            $youmaxContainerList.parent("#youmax-video-list-div").css("min-height", i), $youmaxContainerList.find("li").addClass("youmax-dying"), x(e, t)
        },
        x = function(t, i) {
            var o = {
                    items: [],
                    nextPageToken: "youmax-generated"
                },
                n = {
                    data: [],
                    paging: {
                        next: "youmax-generated"
                    }
                };
            cache = t.data("cache"), cacheIndex = t.data("cacheindex");
            var a, s = t.data("youmax_global_options");
            tabId = e(".youmax-tab-hover").attr("id"), "previous" == i ? cacheIndex >= 0 ? (a = cacheIndex - s.maxResults + 1, 0 > a && (a = 0), o.items = cache.slice(a, a + s.maxResults), n.data = cache.slice(a, a + s.maxResults), setTimeout(function() {
                -1 != tabId.indexOf("youtube_channel_uploads_") ? F(o, !1, t, !0) : -1 != tabId.indexOf("youtube_channel_playlists_") ? H(o, !1, t, !0) : -1 != tabId.indexOf("youtube_channel_search_") ? (eventType = e(".youmax-tab-hover").data("eventtype"), isEvent = !1, null != eventType && "" != eventType && (isEvent = !0), G(o, t, !1, isEvent, !0, !0)) : -1 != tabId.indexOf("youtube_channel_events_") ? G(o, t, !1, !0, !0, !0) : -1 != tabId.indexOf("youtube_playlist_videos_") ? F(o, !1, t, !0) : -1 != tabId.indexOf("vimeo_user_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_channel_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_group_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_album_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("query_")
            }, s.minimumFadeTimeout), cacheIndex -= s.maxResults) : (s.showTextInsteadOfIcons ? t.find("#youmax-previous-div").removeClass("youmax-load-more-div-click").html("Done") : t.find("#youmax-previous-div").removeClass("youmax-load-more-div-click").html('<span class="load-more">View More</span>'), t.find("ul#tiles li").removeClass("youmax-dying").fadeTo(0, 1)) : "next" == i && (cacheIndex + s.maxResults + 1 >= cache.length ? _(t) : (a = cacheIndex + s.maxResults + 1, o.items = cache.slice(a, a + s.maxResults), n.data = cache.slice(a, a + s.maxResults), setTimeout(function() {
                -1 != tabId.indexOf("youtube_channel_uploads_") ? F(o, !1, t, !0) : -1 != tabId.indexOf("youtube_channel_playlists_") ? H(o, !1, t, !0) : -1 != tabId.indexOf("youtube_channel_search_") ? (eventType = e(".youmax-tab-hover").data("eventtype"), isEvent = !1, null != eventType && "" != eventType && (isEvent = !0), G(o, t, !1, isEvent, !0, !0)) : -1 != tabId.indexOf("youtube_channel_events_") ? G(o, t, !1, !0, !0, !0) : -1 != tabId.indexOf("youtube_playlist_videos_") ? F(o, !1, t, !0) : -1 != tabId.indexOf("vimeo_user_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_channel_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_group_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("vimeo_album_videos_") ? q(n, !1, t, !0) : -1 != tabId.indexOf("query_")
            }, s.minimumFadeTimeout), cacheIndex += s.maxResults), cacheIndex < -1 && (cacheIndex = -1)), t.data("cache", cache), t.data("cacheindex", cacheIndex)
        },
        g = function(t, i) {
            e(t).html('<i class="fa fa-ellipsis-h fa-2x"></i>').attr("disabled", "disabled");
            var o = i.data("youmax_global_options");
            "popup" == o.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = i;
            var n = youmaxLoggedInUser.youmaxAccessToken;
            if (null != n && "" != n) {
                var a = $youmaxPlayBox.find(".youmax-comment-textbox").val();
                if (null == a || "" == a.trim()) return alert("Please enter a valid comment.."), void $youmaxPlayBox.find(".youmax-add-comment-button").removeAttr("disabled").html('<i class="fa fa-send fa-2x"></i>');
                a = a.trim(), videoId = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-show-button").attr("id"), channelId = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-show-button").data("channelid"), videoId = videoId.substring(videoId.indexOf("_") + 1), b(i, videoId, n, o.apiKey, a, channelId)
            } else gapi.auth.signIn({
                clientid: o.clientId,
                cookiepolicy: "single_host_origin",
                callback: "youmaxSaveToken",
                scope: "https://www.googleapis.com/auth/youtube.force-ssl"
            })
        },
        b = function(t, i, o, n, a, s) {
            var r = t.data("youmax_global_options"),
                l = "https://www.googleapis.com/youtube/v3/commentThreads?part=snippet&shareOnGooglePlus=false&fields=snippet&key=" + r.apiKey,
                d = '{"snippet":{"channelId":"' + s + '","videoId":"' + i + '","topLevelComment":{"snippet":{"textOriginal":"' + a + '"}}}}';
            e.ajax({
                url: l,
                type: "post",
                crossDomain: !0,
                data: d,
                beforeSend: function(e) {
                    e.setRequestHeader("Authorization", "Bearer " + o), e.setRequestHeader("Content-Type", "application/json"), e.setRequestHeader("Content-Length", d.length)
                },
                success: function(i, o) {
                    var n = i.snippet.topLevelComment.snippet.authorDisplayName,
                        s = i.snippet.topLevelComment.snippet.authorProfileImageUrl,
                        r = t.data("youmax_translator_text"),
                        l = t.data("youmax_global_options");
                    "popup" == l.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = t, $youmaxPlayBox.find("#youmax-encloser-comments").prepend('<div  class="youmax-video-comment"><div class="youmax-from"><div class="youmax-from-img" style="background-image:url(\'' + s + '\');"></div><div class="youmax-from-name">' + n + '</div><div class="youmax-published">' + r.now + '</div></div><div class="youmax-comment"><span class="youmax-comment-content">' + a + "</span><div></div>"), $youmaxPlayBox.find(".youmax-add-comment-button").removeAttr("disabled").html('<i class="fa fa-send fa-2x"></i>'), $youmaxPlayBox.find(".youmax-comment-textbox").val("")
                },
                error: function(e, t, i) {
                    alert("Could not Post - " + i), console.log(e), console.log("Desc: " + t + "\nErr:" + i)
                }
            })
        },
        _ = function(e) {
            $youmaxLoadMoreDiv = w(e), e.find("#youmax-encloser").empty().hide();
            var i = e.find(".youmax-tab.youmax-tab-hover").attr("id"),
                s = $youmaxLoadMoreDiv.data("nextpagetoken");
            null != s && "undefined" != s && "" != s ? -1 != i.indexOf("youtube_channel_uploads_") ? (innerId = i.substring(24), t(innerId, s, e)) : -1 != i.indexOf("youtube_channel_playlists_") ? (innerId = i.substring(26), f(innerId, s, e)) : -1 != i.indexOf("youtube_channel_search_") ? ne(i, s, e) : -1 != i.indexOf("youtube_channel_events_") ? (innerId = i.substring(23), l(innerId, s, e)) : -1 != i.indexOf("youtube_playlist_videos_") ? (innerId = i.substring(24), t(innerId, s, e)) : -1 != i.indexOf("vimeo_user_videos_") ? (innerId = i.substring(18), o(innerId, s, e)) : -1 != i.indexOf("vimeo_channel_videos_") ? (innerId = i.substring(21), n(innerId, s, e)) : -1 != i.indexOf("vimeo_group_videos_") ? (innerId = i.substring(19), a(innerId, s, e)) : -1 != i.indexOf("vimeo_album_videos_") ? (innerId = i.substring(19), r(innerId, s, e)) : -1 != i.indexOf("query_") && (innerId = i.substring(6), ae(innerId, s, e)) : C(e)
        },
        w = function(e, t) {
            var i, o = e.data("youmax_global_options");
            return o.showTextInsteadOfIcons ? "loadmore" == o.loadMode ? (i = e.find("#youmax-load-more-div"), i.html("Loading..")) : -1 != o.loadMode.indexOf("paginate") && ("previous" == t ? (i = e.find("#youmax-previous-div"), i.html("Loading..")) : (i = e.find("#youmax-next-div"), i.html("Loading.."))) : "loadmore" == o.loadMode ? (i = e.find("#youmax-load-more-div"), i.html('<i class="fa fa-ellipsis-h fa-5x"></i>')) : -1 != o.loadMode.indexOf("paginate") && ("previous" == t ? (i = e.find("#youmax-previous-div"), i.html('<i class="fa fa-ellipsis-h fa-5x"></i>')) : (i = e.find("#youmax-next-div"), i.html('<i class="fa fa-ellipsis-h fa-5x"></i>'))), i.addClass("youmax-load-more-div-click"), i
        },
        C = function(e) {
            var t, i = e.data("youmax_global_options");
            i.showTextInsteadOfIcons ? "loadmore" == i.loadMode ? (t = e.find("#youmax-load-more-div"), t.html("All Done")) : -1 != i.loadMode.indexOf("paginate") && (t = e.find("#youmax-next-div"), t.html("Done"), e.find("ul#tiles li").removeClass("youmax-dying").fadeTo(0, 1)) : "loadmore" == i.loadMode ? (t = e.find("#youmax-load-more-div"), t.html('<span class="load-more">View More</span>')) : -1 != i.loadMode.indexOf("paginate") && (t = e.find("#youmax-next-div"), t.html('<span class="load-more">View More</span>'), e.find("ul#tiles li").removeClass("youmax-dying").fadeTo(0, 1)), t.removeClass("youmax-load-more-div-click")
        },
        k = function(t, i) {
            var o = i.data("youmax_global_options"),
                n = o.apiKey;
            o.channelId = t, apiUrl = "https://www.googleapis.com/youtube/v3/channels?part=brandingSettings%2Csnippet%2Cstatistics%2CcontentDetails&id=" + t + "&key=" + n, e.ajax({
                url: apiUrl,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    z(e, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        T = function(t, i) {
            e.ajax({
                url: t,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    k(e.items[0].id, i)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        I = function(t, i, o, n) {
            var a = o.data("youmax_global_options");
            apiUrl = "https://www.googleapis.com/youtube/v3/channels?part=id&forUsername=" + t + "&key=" + a.apiKey, e.ajax({
                url: apiUrl,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    -1 != i.indexOf("youtube_channel_search_") ? (o.find("#" + i).attr("data-restricttochannels", e.items[0].id), o.find("#" + i).data("restricttochannels", e.items[0].id), o.find('option[value="' + i + '"]').attr("data-restricttochannels", e.items[0].id), o.find('option[value="' + i + '"]').data("restricttochannels", e.items[0].id), n && o.find("#" + i).click()) : (o.find("#" + i + t).attr("id", i + e.items[0].id), o.find('option[value="' + i + t + '"]').attr("value", i + e.items[0].id), "youtube_channel_uploads_" == i ? L(e.items[0].id, i, o, n) : n && o.find("#" + i + e.items[0].id).click())
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        L = function(t, i, o, n) {
            var a = o.data("youmax_global_options");
            apiUrl = "https://www.googleapis.com/youtube/v3/channels?part=brandingSettings%2Csnippet%2Cstatistics%2CcontentDetails&id=" + t + "&key=" + a.apiKey, e.ajax({
                url: apiUrl,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    o.find("#" + i + t).attr("id", i + e.items[0].contentDetails.relatedPlaylists.uploads), o.find('option[value="' + i + t + '"]').attr("value", i + e.items[0].contentDetails.relatedPlaylists.uploads), n && o.find("#" + i + e.items[0].contentDetails.relatedPlaylists.uploads).click()
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        E = function(t, i, o) {
            var n = i.data("youmax_global_options"),
                a = n.apiKey,
                s = "";
            o && (s = "%2CliveStreamingDetails"), apiVideoStatURL = "https://www.googleapis.com/youtube/v3/videos?part=statistics%2CcontentDetails" + s + "&id=" + t + "&key=" + a, e.ajax({
                url: apiVideoStatURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    $(e, i, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        O = function(e) {
            e && e.overrideMimeType && e.overrideMimeType("application/j-son;charset=UTF-8")
        },
        S = function(e) {
            return e = parseInt(e, 10), 1e3 > e || (e = 1e6 > e ? Math.round(e / 1e3) + "K" : 1e9 > e ? (e / 1e6).toFixed(1) + "M" : (e / 1e9).toFixed(1) + "B"), e
        },
        P = S,
        R = S,
        M = D,
        D = function(e) {
            var t = "";
            if (null == e || "0" == e) return "";
            for (e = "" + e; e.length > 0;) {
                if (!(e.length > 3)) {
                    t = e + t;
                    break
                }
                t = "," + e.substring(e.length - 3) + t, e = e.substring(0, e.length - 3)
            }
            return t
        },
        B = function(e) {
            return min = parseInt(e / 60, 10), sec = e - 60 * min, sec < 10 && (sec = "0" + sec), min >= 60 ? (hours = parseInt(min / 60, 10), min = e - 60 * hours, min < 10 && (min = "0" + min), hours + ":" + min + ":" + sec) : min + ":" + sec
        },
        V = function(e) {
            var t, i;
            e = e.replace("PT", "").replace("S", "").replace("M", ":").replace("H", ":");
            var o = e.split(":");
            i = o[0];
            for (var n = 1; n < o.length; n++) t = o[n], "" == t ? i += ":00" : (t = parseInt(t, 10), i += 10 > t ? ":0" + t : ":" + t);
            return 1 == o.length && (i = "0:" + i), i
        },
        z = function(e, t) {
            var i = t.data("youmax_global_options"),
                o = t.data("youmax_translator_text"),
                n = e.items[0];
            channelId = n.id, channelTitle = n.snippet.title, channelImage = n.snippet.thumbnails["default"].url, channelSubscribers = M(n.statistics.subscriberCount), channelViews = M(n.statistics.viewCount), channelBackgroundImage = n.brandingSettings.image.bannerImageUrl, channelVideos = M(n.statistics.videoCount), channelDescription = n.snippet.description, userWebsite = i.userWebsite, t.find("#youmax-header").css("background-image", "url(" + channelBackgroundImage + ")"), t.find("#youmax-header-wrapper").append('<a href="https://www.youtube.com/channel/' + channelId + '" target="_blank"><div class="youmax-channel-icon"><img src="' + channelImage + '"/></div><div class="youmax-channel-data-holder"><div class="youmax-channel-title">' + channelTitle + '</div>  <div id="youmax-header-counts" class="youmax-generic-header-counts"><span class="youmax-header-posts" title="' + o.videos + '"><span class="youmax-count"><i class="fa fa-video-camera"></i>' + channelVideos + '</span> </span><span class="youmax-header-followers" title="' + o.subscribers + '"><span class="youmax-count"><i class="fa fa-envelope"></i>' + channelSubscribers + '</span></span><span class="youmax-header-following" title="' + o.views + '"><span class="youmax-count"><i class="fa fa-user"></i>' + channelViews + "</span></span></div>  </div></a>"), -1 != i.skin.indexOf("clean") ? (t.find("#youmax-header-wrapper").append('<div id="youmax-header-info"><div id="youmax-header-title">' + channelTitle + '</div><div class="youmax-subscribe-clean-wrapper"><div class="youmax-subscribe"><div class="g-ytsubscribe" data-channelid="' + channelId + '" data-layout="default" data-count="default"></div></div></div><div id="youmax-header-bio">' + channelDescription + '</div><div id="youmax-header-website"><a href="' + userWebsite + '" target="_blank">' + userWebsite + '</a></div><div id="youmax-header-counts"><span class="youmax-header-posts"><span class="youmax-count">' + channelVideos + "</span> " + o.videos + '</span><span class="youmax-header-followers"><span class="youmax-count">' + channelSubscribers + "</span> " + o.subscribers + '</span><span class="youmax-header-following"><span class="youmax-count">' + channelViews + "</span> " + o.views + "</span></div></div>"), t.find("#youmax-select-box").prepend('<div id="youmax-search-holder"><input id="youmax-search-box" type="text" placeholder="' + o.search + '"/><i class="t-icon icon-magnifier youmax-search-icon"></i></div>'), t.find("#youmax-select-box").append('<i class="fa fa-caret-down"></i>')) : (t.find("#youmax-header-wrapper").append('<div id="youmax-stat-holder"><div id="youmax-search-holder-header"><input id="youmax-search-box-header" type="text" placeholder="Search"/><i class="t-icon icon-magnifier youmax-search-icon"></i></div></div>'), t.find("#youmax-header-wrapper").append('&nbsp;&nbsp;&nbsp;&nbsp;<div class="youmax-subscribe"><div class="g-ytsubscribe" data-channelid="' + channelId + '" data-layout="default" data-count="default"></div></div>'), t.find("#youmax-select-box").prepend('<div id="youmax-search-holder"><input id="youmax-search-box" type="text" placeholder="' + o.search + '"/><i class="t-icon icon-magnifier youmax-search-icon"></i></div>'), t.find("#youmax-select-box").append('<i class="fa fa-caret-down"></i>'), t.find("#youmax-select-box").wrap('<div class="youmax-select-box-wrapper">')), i.alwaysUseDropdown && (t.find("#youmax-select-box").css("display", "block"), t.find("#youmax-tabs").hide(), t.find("#youmax-stat-holder").hide()), h()
        },
        $ = function(e, t, i) {
            for (var o, n = t.data("youmax_global_options"), a = (t.data("youmax_translator_text"), e.items), s = 0; s < a.length; s++) videoId = a[s].id, videoViewCount_raw = a[s].statistics.viewCount, videoViewCount = P(videoViewCount_raw), videoDuration = a[s].contentDetails.duration, videoDuration = V(videoDuration), videoDefinition = a[s].contentDetails.definition.toUpperCase(), videoLikeCount_raw = a[s].statistics.likeCount, videoLikeCount = R(videoLikeCount_raw), videoCommentCount_raw = a[s].statistics.commentCount, videoCommentCount = R(videoCommentCount_raw), o = t.find("#youmax-video-list-div #youtube_" + videoId), o.data("views", videoViewCount), o.data("likes", videoLikeCount), -1 != n.skin.indexOf("clean") ? (i && (actualEndTime = a[s].liveStreamingDetails.actualEndTime, actualStartTime = a[s].liveStreamingDetails.actualStartTime, scheduledStartTime = a[s].liveStreamingDetails.scheduledStartTime, null != actualEndTime ? o.append('<div class="youmax-event-tag">Completed Event</div>') : null != actualStartTime ? (watching = D(a[s].liveStreamingDetails.concurrentViewers), o.append('<div class="youmax-event-tag youmax-event-live"><div class="youmax-live-icon"><i class="fa fa-circle"></i></div>Live Event</div>')) : null != scheduledStartTime && (scheduledAt = K(scheduledStartTime), o.append('<div class="youmax-event-tag youmax-event-upcoming">Upcoming Event</div>'))), o.find(".youmax-all-skin-views").empty().append(videoViewCount), o.find(".youmax-all-skin-likes").empty().append(videoLikeCount), o.find(".youmax-all-skin-comments").empty().append(videoCommentCount), o.find(".youmax-clean-time").empty().append(videoDuration)) : (i ? (actualEndTime = a[s].liveStreamingDetails.actualEndTime, actualStartTime = a[s].liveStreamingDetails.actualStartTime, scheduledStartTime = a[s].liveStreamingDetails.scheduledStartTime, null != actualEndTime ? (o.append('<div class="youmax-definition youmax-event-tag">Completed Event</div>'),
                o.append('<div class="youmax-duration">' + videoDuration + "</div>")) : null != actualStartTime ? (watching = D(a[s].liveStreamingDetails.concurrentViewers), o.append('<div class="youmax-definition youmax-event-tag youmax-event-live"><div class="youmax-live-icon"><i class="fa fa-circle"></i></div>Live Event</div>'), o.append('<div class="youmax-duration">' + watching + " watching</div>")) : null != scheduledStartTime && (scheduledAt = K(scheduledStartTime), o.append('<div class="youmax-definition youmax-event-tag youmax-event-upcoming">Upcoming Event</div>'), o.append('<div class="youmax-duration">' + scheduledAt + "</div>"))) : (o.find(".youmax-duration").empty().append(videoDuration), o.find(".youmax-definition").empty().append(videoDefinition)), -1 != n.skin.indexOf("list") ? (o.find(".youmax-all-skin-views").empty().append(videoViewCount), o.find(".youmax-all-skin-likes").empty().append(videoLikeCount), o.find(".youmax-all-skin-comments").empty().append(videoCommentCount)) : -1 != n.skin.indexOf("trend") ? (video_uploaded = o.data("videouploaded"), trend = j(videoViewCount_raw, videoLikeCount_raw, videoCommentCount_raw, video_uploaded, n.hotThreshold, n.trendingThreshold), "trending" == trend ? icon = "fa-bolt" : "hot" == trend ? icon = "fa-fire" : icon = "fa-check", o.find(".youmax-trend-holder").attr("class", "youmax-trend-holder").empty().addClass("youmax-" + trend).append('<i class="fa ' + icon + '"></i> <span class="youmax-trend-text">' + trend + "</span>"), o.find(".youmax-all-skin-views").empty().append(videoViewCount), o.find(".youmax-all-skin-likes").empty().append(videoLikeCount), o.find(".youmax-all-skin-comments").empty().append(videoCommentCount)) : (o.find(".youmax-all-skin-views").empty().append(videoViewCount), -1 != n.skin.indexOf("block") && (o.find(".youmax-all-skin-likes").empty().append(videoLikeCount), o.find(".youmax-all-skin-comments").empty().append(videoCommentCount))))
        },
        j = function(e, t, i, o, n, a) {
            e = null != e && "" != e ? parseInt(e, 10) : 0, t = null != t && "" != t ? parseInt(t, 10) : 0, i = null != i && "" != i ? parseInt(i, 10) : 0, dateDiffMS = Math.abs(new Date - new Date(o)), dateDiffDY = dateDiffMS / 1e3 / 60 / 60 / 24;
            var s = (e + 100 * t + 300 * i) / dateDiffDY;
            return s >= n ? "hot" : s >= a ? "trending" : "classic"
        },
        A = function(t, i, o) {
            var n, a = o.data("youmax_global_options"),
                s = o.data("youmax_translator_text");
            "popup" == a.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = o, n = $youmaxPlayBox.find("#youmax-encloser-comments"), i || n.empty();
            var r = t.items,
                l = t.nextPageToken,
                d = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-more-button");
            if (null != l && "undefined" != l && "" != l ? d.data("nextpagetoken", l) : d.data("nextpagetoken", ""), null == r || 0 == r.length) return n.append('<div id="" class="youmax-video-comment"><div class="youmax-comment" ><span class="youmax-comment-content" style="text-align:center;">No more comments found.</span><div></div>'), d.data("nextpagetoken", ""), void J($youmaxPlayBox, a);
            for (var u = 0; u < r.length; u++) comment = r[u].snippet.topLevelComment.snippet.textDisplay, null != comment && "" != comment && (commentPublished = r[u].snippet.topLevelComment.snippet.publishedAt, authorName = r[u].snippet.topLevelComment.snippet.authorDisplayName, authorImage = r[u].snippet.topLevelComment.snippet.authorProfileImageUrl, n.append('<div  class="youmax-video-comment"><div class="youmax-from"><div class="youmax-from-img" style="background-image:url(\'' + authorImage + '\');"></div><div class="youmax-from-name">' + authorName + '</div><div class="youmax-published">' + Q(commentPublished, s) + ' </div></div><div class="youmax-comment"><span class="youmax-comment-content">' + comment + "</span><div></div>"));
            J($youmaxPlayBox, a)
        },
        W = function(t, i, o) {
            var n, a = o.data("youmax_global_options"),
                s = o.data("youmax_translator_text");
            "popup" == a.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = o, n = $youmaxPlayBox.find("#youmax-encloser-comments"), i || n.empty();
            var r = t.data,
                l = t.paging.next,
                d = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-more-button");
            if (null != l && "undefined" != l && "" != l ? (l = l.substring(l.lastIndexOf("&") + 1), d.data("nextpagetoken", l)) : d.data("nextpagetoken", ""), null == r || 0 == r.length) return n.append('<div id="" class="youmax-video-comment"><div class="youmax-comment" ><span class="youmax-comment-content" style="text-align:center;">No more comments found.</span><div></div>'), d.data("nextpagetoken", ""), void J($youmaxPlayBox, a);
            for (var u = 0; u < r.length; u++) comment = r[u].text, null != comment && "" != comment && (commentPublished = r[u].created_on, authorName = r[u].user.name, null != r[u].user.pictures ? authorImage = r[u].user.pictures.sizes[1].link : authorImage = "http://i1.wp.com/i.vimeocdn.com/portrait/default-green_75x75.png", n.append('<div  class="youmax-video-comment"><div class="youmax-from"><div class="youmax-from-img" style="background-image:url(\'' + authorImage + '\');"></div><div class="youmax-from-name">' + authorName + '</div><div class="youmax-published">' + Q(commentPublished, s) + ' </div></div><div class="youmax-comment"><span class="youmax-comment-content">' + comment + "</span><div></div>"));
            J($youmaxPlayBox, a)
        },
        U = function(e) {
            if (e = e.replace(/"/g, "'"), spotArray = e.match(/(http(s)*:\/\/|www\.).+?(\s|\n|$)/g), null != spotArray)
                for (var t = 0; t < spotArray.length; t++) spotArray[t] = spotArray[t].trim(), 0 == spotArray[t].indexOf("www.") ? replaceLink = "http://" + spotArray[t] : replaceLink = spotArray[t], e = e.replace(spotArray[t], "<a target='_blank' href='" + replaceLink + "' class='famax-link'>" + spotArray[t] + "</a>");
            return e
        },
        F = function(t, i, o, n) {
            var a = [],
                s = o.find("ul"),
                r = "";
            i || 0 == o.find(".youmax-tab-hover").length && o.find("#youmax-showing-title").append('<div id="' + o.data("youmax_current_playlist_id") + '" class="youmax-tab youmax-tab-hover youmax-showing-search-title"><i title="Back to Playlists" id="youmax-back-to-playlists" class="fa fa-chevron-circle-left fa-lg"></i> <i class="fa fa-bars fa-lg youmax-showing-playlist-icon"></i>' + o.data("youmax_current_playlist_name") + "</div>").show();
            var l, d = t.items,
                u = t.nextPageToken,
                c = o.data("youmax_global_options"),
                p = o.data("youmax_translator_text");
            "loadmore" == c.loadMode ? l = o.find("#youmax-load-more-div") : -1 != c.loadMode.indexOf("paginate") && (l = o.find("#youmax-next-div"), i && (n = !0), i = !1), null != u && "undefined" != u && "" != u ? -1 == u.indexOf("youmax-generated") && l.data("nextpagetoken", u) : l.data("nextpagetoken", "");
            for (var m = 0; m < d.length; m++) videoId = d[m].snippet.resourceId.videoId, videoTitle = d[m].snippet.title, videoDescription = d[m].snippet.description, videoDescription = U(videoDescription), s.find("#youtube_" + videoId).length > 0 || (channelId = d[m].snippet.channelId, null != d[m].snippet.thumbnails ? (videoThumbnail = d[m].snippet.thumbnails.medium.url, videoUploaded = d[m].snippet.publishedAt, a.push(videoId), videoLink = "https://www.youtube.com/watch?v=" + videoId, r += N("youtube", videoId, videoTitle, videoDescription, null, null, null, videoUploaded, videoLink, videoThumbnail, null, null, channelId, c, p)) : videoThumbnail = "");
            $items = e(r), s.append($items), X(o, "video", i, n, $items), E(a, o), -1 == c.loadMode.indexOf("paginate") || null != u && -1 != u.indexOf("youmax-generated") || d.length > 0 && (cache = o.data("cache"), cacheIndex = o.data("cacheindex"), cache = cache.concat(d), cacheIndex = cache.length - d.length - 1, o.data("cache", cache), o.data("cacheindex", cacheIndex))
        },
        q = function(t, i, o, n) {
            var a, s = "",
                r = o.find("ul"),
                l = t.data,
                d = t.paging.next,
                u = o.data("youmax_global_options"),
                c = o.data("youmax_translator_text");
            "loadmore" == u.loadMode ? a = o.find("#youmax-load-more-div") : -1 != u.loadMode.indexOf("paginate") && (a = o.find("#youmax-next-div"), i && (n = !0), i = !1), null != d && "undefined" != d && "" != d ? -1 == d.indexOf("youmax-generated") && (d = d.substring(d.lastIndexOf("&") + 1), a.data("nextpagetoken", d)) : a.data("nextpagetoken", "");
            for (var p = 0; p < l.length; p++) videoId = l[p].uri.substring(l[p].uri.lastIndexOf("/") + 1), videoLink = "https://vimeo.com/" + videoId, videoTitle = l[p].name, videoDescription = l[p].description, null == videoDescription ? videoDescription = "" : videoDescription = U(videoDescription), null != l[p].pictures.sizes ? (videoThumbnail = l[p].pictures.sizes[2].link, videoUploaded = l[p].created_time, videoViewCount_raw = l[p].stats.plays, videoDuration = l[p].duration, videoLikeCount_raw = l[p].metadata.connections.likes.total, videoCommentCount_raw = l[p].metadata.connections.comments.total, s += N("vimeo", videoId, videoTitle, videoDescription, videoViewCount_raw, videoLikeCount_raw, videoCommentCount_raw, videoUploaded, videoLink, videoThumbnail, videoDuration, null, null, u, c)) : videoThumbnail = "";
            $items = e(s), r.append($items), X(o, "video", i, n, $items), -1 == u.loadMode.indexOf("paginate") || null != d && -1 != d.indexOf("youmax-generated") || l.length > 0 && (cache = o.data("cache"), cacheIndex = o.data("cacheindex"), cache = cache.concat(l), cacheIndex = cache.length - l.length - 1, o.data("cache", cache), o.data("cacheindex", cacheIndex))
        },
        N = function(e, t, i, o, n, a, s, r, l, d, u, c, p, m, h) {
            var f = "";
            return null == n ? (videoViewCount = "??", n = 0) : videoViewCount = P(n), null != a ? videoLikeCount = R(a) : (videoLikeCount = "??", a = 0), null != s ? videoCommentCount = R(s) : (videoCommentCount = "??", s = 0), null != u ? "vimeo" == e && (u = B(u)) : u = "??", null == p && (p = ""), "vimeo" == e && m.showVimeoLikesInsteadOfViews ? primaryAttributeString = '<span class="youmax-list-thumbnail-icon"><i class="fa fa-heart"></i></span> <span class="youmax-thumbnail-primary-attribute">' + videoLikeCount + '</span> <span class="youmax-views-text">' + h.likes + "</span> " : primaryAttributeString = '<span class="youmax-list-thumbnail-icon"><i class="fa fa fa-dot-circle-o"></i></span> <span class="youmax-all-skin-views">' + videoViewCount + '</span> <span class="youmax-views-text">' + h.views + "</span> ", "thumbnail" == m.displayVideo ? (frame_source = oe(t, e, !1, m), videoThumbnailString = '<div class="fluid-width-video-wrapper" style="padding-top:' + 100 * m.aspectRatio + '%;"><iframe id="youmax-encloser-video" style="width:100%;" src="' + frame_source + '" frameborder="0" allowfullscreen></iframe></div>') : "link" == m.displayVideo ? videoThumbnailString = '<a href="' + l + '" target="_blank"><img class="youmax-main-thumbnail" href="' + l + '" src="' + d + '"></a>' : videoThumbnailString = '<img class="youmax-main-thumbnail" href="' + l + '" src="' + d + '">', f = '<li id="' + e + "_" + t + '" data-description="' + o + '" data-views="' + videoViewCount + '" data-likes="' + videoLikeCount + '" data-comments="' + videoCommentCount + '" data-videouploaded="' + r + '" data-channelid="' + p + '" class="youmax-grid-item youmax-hidden" ><div class="youmax-thumbnail-image-wrapper">' + videoThumbnailString + '<div class="youmax-play-overlay"><div class="youmax-play-icon-holder"><i class="fa fa-play"></i></div></div></div><p><span class="youmax-title-desc-holder"><span class="youmax-video-list-title">' + i + '</span><span class="youmax-video-list-description">' + o + "</span></span>", -1 != m.skin.indexOf("list") ? f += '<span class="youmax-view-date-holder"><span class="youmax-video-list-views" title="views"><span class="youmax-list-thumbnail-icon"><i class="fa fa fa-dot-circle-o"></i></span> <span class="youmax-all-skin-views">' + videoViewCount + '</span> <span class="youmax-views-text">' + h.views + '</span></span> <span class="youmax-views-date-separator">|</span><span class="youmax-video-list-date">' + Q(r, h) + '</span> <span class="youmax-video-list-likes" title="likes"> <span class="youmax-list-thumbnail-icon"><i class="fa fa fa-heart"></i></span> <span class="youmax-all-skin-likes">' + videoLikeCount + '</span> <span class="youmax-views-text">' + h.likes + '</span></span><span class="youmax-video-list-comments" title="comments"> <span class="youmax-list-thumbnail-icon"><i class="fa fa fa-comment"></i></span> <span class="youmax-all-skin-comments">' + videoCommentCount + '</span> <span class="youmax-views-text">' + h.comments + "</span></span></span></p>" : -1 != m.skin.indexOf("trend") ? (trend = j(n, a, s, r, m.hotThreshold, m.trendingThreshold), "trending" == trend ? icon = "fa-bolt" : "hot" == trend ? icon = "fa-fire" : icon = "fa-check", f += '<span class="youmax-trend-link-holder"><span class="youmax-trend-holder youmax-' + trend + '"><i class="fa ' + icon + '"></i> <span class="youmax-trend-text">' + trend + '</span></span>   <a class="youmax-thumbnail-link" href="' + l + '" target="_blank"><span class="youmax-link"><i class="fa fa-link"></i></span></a></span>', f += '<span class="youmax-view-date-holder"><span class="youmax-video-list-views" title="views"><span class="youmax-list-thumbnail-icon"><i class="fa fa fa-dot-circle-o"></i></span> <span class="youmax-all-skin-views">' + videoViewCount + '</span> <span class="youmax-views-text">' + h.views + '</span></span> <span class="youmax-views-date-separator">|</span><span class="youmax-video-list-date">' + Q(r, h) + '</span> <span class="youmax-video-list-likes" title="likes"> <span class="youmax-list-thumbnail-icon"><i class="fa fa fa-heart"></i></span> <span class="youmax-all-skin-likes">' + videoLikeCount + '</span> <span class="youmax-views-text">' + h.likes + '</span></span><span class="youmax-video-list-comments" title="comments"> <span class="youmax-list-thumbnail-icon"><i class="fa fa fa-comment"></i></span> <span class="youmax-all-skin-comments">' + videoCommentCount + '</span> <span class="youmax-views-text">' + h.comments + "</span></span></span></p>") : f += '<span class="youmax-view-date-holder"><span class="youmax-video-list-views" title="views">' + primaryAttributeString + '</span><span class="youmax-views-date-separator">|</span><span class="youmax-video-list-date">' + Q(r, h) + "</span></span></p>", -1 != m.skin.indexOf("clean") ? ("vimeo" == e && m.showVimeoLikesInsteadOfViews ? (f += '<div class="youmax-definition"><i class="fa fa-heart fa-1x"></i> <span class="youmax-all-skin-likes">' + videoLikeCount + "</span> </div>", f += '<div class="youmax-duration"><i class="fa fa-comment fa-1x"></i> <span class="youmax-all-skin-comments">' + videoCommentCount + "</span> </div>") : (f += '<div class="youmax-duration"><i class="fa fa-heart fa-1x"></i> <span class="youmax-all-skin-likes">' + videoLikeCount + "</span> </div>", f += '<div class="youmax-definition"><i class="fa fa-volume-off fa-1x"></i> <span class="youmax-all-skin-views">' + videoViewCount + "</span> </div>"), f += '<div class="youmax-clean-overlay-holder"><span class="youmax-clean-title">' + i + '</span><span class="youmax-clean-time">' + u + "</span></span></div>") : ("thumbnail" != m.displayVideo && (f += '<div class="youmax-duration">' + u + "</div>", "youtube" == e && (f += '<div class="youmax-definition">' + c + "</div>")), -1 != m.skin.indexOf("block") && (f += '<div class="youmax-like-comment-holder"><div class="youmax-like-box"><i class="fa fa-heart"></i> <span class="youmax-all-skin-likes">' + videoLikeCount + '</span></div><div class="youmax-comment-box"><i class="fa fa-comment"></i><span class="youmax-all-skin-comments">' + videoCommentCount + "</span></div></div>")), f += "</li>"
        },
        H = function(t, i, o, n) {
            var a, s = "",
                r = o.find("ul"),
                l = t.items,
                d = t.nextPageToken,
                u = o.data("youmax_global_options"),
                c = o.data("youmax_translator_text");
            "loadmore" == u.loadMode ? a = o.find("#youmax-load-more-div") : -1 != u.loadMode.indexOf("paginate") && (a = o.find("#youmax-next-div"), i && (n = !0), i = !1), null != d && "undefined" != d && "" != d ? -1 == d.indexOf("youmax-generated") && a.data("nextpagetoken", d) : a.data("nextpagetoken", "");
            for (var p = 0; p < l.length; p++) playlistId = l[p].id, videoCount = l[p].contentDetails.itemCount, playlistTitle = l[p].snippet.title, null != l[p].snippet.thumbnails ? (playlistThumbnail = l[p].snippet.thumbnails.medium.url, playlistUploaded = l[p].snippet.publishedAt, s += '<li id="youtube_playlist_videos_' + playlistId + '" class="youmax-playlist-thumbnail youmax-grid-item youmax-hidden" ><div class="youmax-thumbnail-image-wrapper" ><img class="youmax-main-thumbnail" href="https://www.youtube.com/watch?v=' + playlistId + '" src="' + playlistThumbnail + '"></div><div class="youmax-playlist-video-count-wrapper"><div class="youmax-playlist-video-count-box"><span class="youmax-playlist-video-count">' + videoCount + '</span><br>VIDEOS<br><div class="youmax-playlist-line-wrapper"><span class="youmax-playlist-line"></span><br><span class="youmax-playlist-line"></span><br><span class="youmax-playlist-line"></span></div></div></div><p><span class="youmax-video-list-title">' + playlistTitle + '</span><span class="youmax-video-list-views youmax-video-list-date-playlist">' + Q(playlistUploaded, c) + ' </span></p><div class="youmax-clean-playlist-title">' + playlistTitle + "</div></li>") : playlistThumbnail = "";
            $items = e(s), r.append($items), X(o, "playlist", i, n, $items), -1 == u.loadMode.indexOf("paginate") || null != d && -1 != d.indexOf("youmax-generated") || l.length > 0 && (cache = o.data("cache"), cacheIndex = o.data("cacheindex"), cache = cache.concat(l), cacheIndex = cache.length - l.length - 1, o.data("cache", cache), o.data("cacheindex", cacheIndex))
        },
        Y = function(e, t, i, o) {
            if (t = t.replace(/%20/g, " "), !i && (0 == o.find(".youmax-tab-hover").length && o.find("#youmax-showing-title").append('<div id="query_' + t + '" class="youmax-tab youmax-tab-hover youmax-showing-search-title"><i class="t-icon icon-magnifier youmax-showing-search-icon"></i>' + t + "</div>").show(), null == e.items || 0 == e.items.length)) {
                var n = o.find("ul");
                n.empty().append('<div class="youmax-not-found"><span style="opacity:0;">.</span><br><br><br><br><br><br>No videos found..<br><br><br><br><br><br><span style="opacity:0;">.</span></div>')
            }
            G(e, o, null, null, i)
        },
        G = function(t, i, o, n, a, s) {
            var r = [],
                l = "",
                d = i.find("ul"),
                u = i.data("youmax_global_options"),
                c = i.data("youmax_translator_text"),
                p = t.items;
            if (!o) {
                var m, h = t.nextPageToken;
                "loadmore" == u.loadMode ? m = i.find("#youmax-load-more-div") : -1 != u.loadMode.indexOf("paginate") && (m = i.find("#youmax-next-div"), a && (s = !0), a = !1), null != h && "undefined" != h && "" != h ? -1 == h.indexOf("youmax-generated") && m.data("nextpagetoken", h) : m.data("nextpagetoken", "")
            }
            if (null != p && 0 != p.length) {
                i.find(".youmax-not-found").remove();
                for (var f = 0; f < p.length; f++) o ? videoId = p[f].id : videoId = p[f].id.videoId, d.find("#youtube_" + videoId).length > 0 || (videoTitle = p[f].snippet.title, null != p[f].snippet.thumbnails ? (videoThumbnail = p[f].snippet.thumbnails.medium.url, n && (eventType = p[f].snippet.liveBroadcastContent, "upcoming" == eventType ? videoThumbnail = videoThumbnail.replace(".jpg", "_live.jpg") : "live" == eventType ? videoThumbnail = videoThumbnail.replace(".jpg", "_live.jpg") : "completed" == eventType), videoUploaded = p[f].snippet.publishedAt, videoDescription = p[f].snippet.description, videoDescription = U(videoDescription), channelId = p[f].snippet.channelId, r.push(videoId), videoLink = "https://www.youtube.com/watch?v=" + videoId, l += N("youtube", videoId, videoTitle, videoDescription, null, null, null, videoUploaded, videoLink, videoThumbnail, null, null, channelId, u, c)) : videoThumbnail = "");
                $items = e(l), d.append($items), X(i, "video", a, s, $items), E(r, i, n), -1 == u.loadMode.indexOf("paginate") || null != h && -1 != h.indexOf("youmax-generated") || p.length > 0 && (cache = i.data("cache"), cacheIndex = i.data("cacheindex"), cache = cache.concat(p), cacheIndex = cache.length - p.length - 1, i.data("cache", cache), i.data("cacheindex", cacheIndex))
            }
        },
        K = function(e) {
            var t = new Date(e);
            return month = ["Jan", "Feb", "", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], t.getMinutes() < 10 ? minutes = "0" + t.getMinutes() : minutes = t.getMinutes(), t.getDate() + " " + month[t.getMonth() + 1] + " " + t.getHours() + ":" + minutes + " GMT"
        },
        Q = function(e, t) {
            return null == e || "" == e || "undefined" == e ? "?" : (dateDiffMS = Math.abs(new Date - new Date(e)), dateDiffHR = dateDiffMS / 1e3 / 60 / 60, dateDiffHR > 24 ? (dateDiffDY = dateDiffHR / 24, dateDiffDY > 30 ? (dateDiffMH = dateDiffDY / 30, dateDiffMH > 12 ? (dateDiffYR = dateDiffMH / 12, dateDiffYR = Math.round(dateDiffYR), dateDiffYR <= 1 ? dateDiffYR + " " + t.year + " " + t.ago : dateDiffYR + " " + t.years + " " + t.ago) : (dateDiffMH = Math.round(dateDiffMH), dateDiffMH <= 1 ? dateDiffMH + " " + t.month + " " + t.ago : dateDiffMH + " " + t.months + " " + t.ago)) : (dateDiffDY = Math.round(dateDiffDY), dateDiffDY <= 1 ? dateDiffDY + " " + t.day + " " + t.ago : dateDiffDY + " " + t.days + " " + t.ago)) : (dateDiffHR = Math.round(dateDiffHR), dateDiffHR < 1 ? t.now : 1 == dateDiffHR ? dateDiffHR + " " + t.hour + " " + t.ago : dateDiffHR + " " + t.hours + " " + t.ago))
        },
        X = function(t, i, o, n, a) {
            var s = t.data("youmax_global_options"),
                r = t.find("ul");
            r.imagesLoaded().always(function() {
                t.find(".youmax-loading-div").remove(), r.find("li.youmax-hidden").removeClass("youmax-hidden"), o ? r.masonry("appended", a) : n ? ($oldItems = r.find(".youmax-dying"), r.masonry("remove", $oldItems).masonry("layout"), r.masonry("appended", a)) : (null != r.data("masonry") && r.masonry("destroy"), $youmaxGrid = r.masonry({
                    columnWidth: ".youmax-grid-item",
                    percentPosition: !0
                }), setTimeout(function() {
                    console.log("Youmax Re-Layout"), t.find("ul").masonry("layout")
                }, s.updateLayoutDelay)), "playlist" == i ? "playall" == s.playlistAction ? ee(t, !0) : t.find("#youmax-video-list-div .youmax-main-thumbnail").click(function() {
                    $youmaxPlaylistThumbnail = e(this).parents("li").first(), youmaxPlaylistId = $youmaxPlaylistThumbnail.attr("id"), ue(youmaxPlaylistId, t), youmax_current_playlist_name = $youmaxPlaylistThumbnail.find(".youmax-video-list-title").text(), t.data("youmax_current_playlist_name", youmax_current_playlist_name), t.data("youmax_current_playlist_id", youmaxPlaylistId)
                }) : ee(t), Z(t), -1 != s.skin.indexOf("trend") && t.find("#tiles li:first-child").width() < 280 && t.find(".youmax-video-list-date").hide()
            })
        },
        Z = function(e) {
            var t, i = e.data("youmax_global_options");
            console.log('working...123')
            i.showTextInsteadOfIcons ? "loadmore" == i.loadMode ? (t = e.find("#youmax-load-more-div"), t.html("Load More")) : -1 != i.loadMode.indexOf("paginate") && (t = e.find("#youmax-next-div"), t.html("Next"), e.find("#youmax-previous-div").html("Previous")) : "loadmore" == i.loadMode ? (t = e.find("#youmax-load-more-div"), t.html('<span class="load-more">View More</span>')) : -1 != i.loadMode.indexOf("paginate") && (t = e.find("#youmax-next-div"), t.html('<i class="fa fa-caret-right fa-5x"></i>'), e.find("#youmax-previous-div").html('<i class="fa fa-caret-left fa-5x"></i>')), t.removeClass("youmax-load-more-div-click"), e.find("#youmax-previous-div").removeClass("youmax-load-more-div-click")
        },
        J = function(e, t) {
            var i = e.find(".youmax-encloser-comment-button.youmax-more-button");
            i.removeClass("youmax-load-more-comments-clicked"), t.showTextInsteadOfIcons ? i.html("Load More Comments") : i.html('<i class="fa fa-plus fa-3x"></i>')
        },
        ee = function(t, i) {
            var o = t.data("youmax_global_options"),
                n = t.data("youmax_translator_text"),
                a = "",
                s = "";
            "popup" == o.displayVideo ? (a = i ? o.videoProtocol + "//www.youtube.com/embed?listType=playlist&list=%id%&rel=0" : o.videoProtocol + "//www.youtube.com/embed/%id%?rel=0", o.autoPlayVideo && (a += "&autoplay=1"), a += o.showTitleInVideoPlayer ? "&showinfo=1" : "&showinfo=0", a += "&theme=" + o.videoPlayerTheme, s = o.videoProtocol + "//player.vimeo.com/video/%id%", o.autoPlayVideo && (s += "?autoplay=1"), o.showTextInsteadOfIcons ? (youmaxExtraPopupClasses = "youmax-text-instead-of-icons", youmaxShowCommentsText = "Show Comments", youmaxMoreCommentsText = "Load More Comments") : (youmaxExtraPopupClasses = "", youmaxShowCommentsText = '<i class="fa fa-comments fa-3x"></i>', youmaxMoreCommentsText = '<i class="fa fa-plus fa-3x"></i>'), t.find("#youmax-video-list-div .youmax-main-thumbnail").magnificPopup({
                type: "iframe",
                gallery: {
                    enabled: !0
                },
                iframe: {
                    markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe><div id="photo-detail-holder"><div class="photo-popup-title"></div><div class="photo-popup-description photo-popup-description-limited"></div><div class="youmax-full-description-button-wrapper"><div class="youmax-full-description-button">More..</div></div><div class="photo-popup-stats"><div class="media-views"></div><div class="media-likes"> </div><div class="media-uploaded"></div> <div type="button" class="youmax-share-video-button"><i class="fa fa-share-alt fa-2x"></i></div></div>  <div class="youmax-show-button-wrapper"><div class="youmax-encloser-comment-button youmax-show-button youmax-popup-show-button">' + youmaxShowCommentsText + '</div></div> <div id="youmax-encloser-comment-holder" class="youmax-encloser-comment-holder-popup"><div class="youmax-video-comment youmax-commentbox-holder"><textarea class="youmax-comment-textbox" placeholder="' + n.thoughts + '"></textarea><button type="button" class="youmax-add-comment-button"><i class="fa fa-google-plus fa-2x"></i><span class="youmax-google-login-text">Login</span></button></div><div id="youmax-encloser-comments"></div><div class="youmax-encloser-comment-button youmax-more-button">' + youmaxMoreCommentsText + "</div></div> </div></div>",
                    patterns: {
                        youtube: {
                            src: a
                        },
                        vimeo: {
                            src: s
                        }
                    }
                },
                preloader: !1,
                showCloseBtn: !0,
                closeBtnInside: !0,
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: o.alignPopupToTop,
                removalDelay: 500,
                mainClass: "youmax-popup " + youmaxExtraPopupClasses,
                callbacks: {
                    change: function(i, o, n) {
                        var a = e(this.currItem.el).parents("li").first();
                        console.log(a);
                        te(a, t)
                    },
                    open: function() {
                    	var _$ = jQuery;
                      	var closeBtn = _$('.mfp-close').clone();
                      	var mfpContainer = _$('.mfp-wrap');        
                      	mfpContainer.append(closeBtn);  
                	},
                    close: function() {
                      var _$ = jQuery;
                      var mfpContainer = _$('.mfp-wrap'); 
                      mfpContainer.find('> .mfp-close').remove();	
                    }

                }
            })) : "inline" == o.displayVideo || "newpage" == o.displayVideo ? (t.find("#youmax-video-list-div .youmax-main-thumbnail").click(function() {
                $baseElement = e(this).parents("li").first(), ie($baseElement, !0, !0, t, i)
            }), "inline" == o.displayVideo && o.displayFirstVideoOnLoad && (setTimeout(function() {
                $baseElement = t.find("#youmax-video-list-div li:first"), ie($baseElement, !1, !0, t, i)
            }, 100), o.displayFirstVideoOnLoad = !1, t.data("youmax_global_options", o)), "inline" == o.displayVideo && "" != o.featuredVideo && (-1 != o.featuredVideo.indexOf("youtube.com") ? (video_type = "youtube", video_id = o.featuredVideo.substring(o.featuredVideo.lastIndexOf("?v=") + 3)) : -1 != o.featuredVideo.indexOf("vimeo.com") && (video_type = "vimeo", video_id = o.featuredVideo.substring(o.featuredVideo.lastIndexOf("/") + 1)), "youtube" == video_type ? u(video_id, t, !1, !1) : "vimeo" == video_type && c(video_id, t, !1, !1), o.featuredVideo = "", t.data("youmax_global_options", o))) : "thumbnail" == o.displayVideo
        },
        te = function(t, i) {
          console.log(t,'this is T');
            var o = i.data("youmax_global_options"),
                n = i.data("youmax_translator_text");
                video_likes = t.data("likes"), video_comments = t.data("comments"), video_views = t.data("views"), video_description = t.data("description"), video_uploaded = t.find(".youmax-video-list-date").text(), video_id_with_type = t.attr("id"),console.log(video_id_with_type,'video type'), video_type = video_id_with_type.substring(0, video_id_with_type.indexOf("_")), video_id = video_id_with_type.substring(video_id_with_type.indexOf("_") + 1), video_title = t.find(".youmax-video-list-title").text(), channel_id = t.data("channelid"), setTimeout(function() {
                "popup" == o.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = i, null != video_title && $youmaxPlayBox.find(".photo-popup-title").html(video_title), null != video_description && (video_description = video_description.replace(/\n/g, "<br>"), $youmaxPlayBox.find(".photo-popup-description").html(video_description)), o.showVimeoLikesInsteadOfViews && "vimeo" == video_type ? (null != video_comments && $youmaxPlayBox.find(".media-likes").html('<i class="fa fa-comment"></i>' + video_comments + " " + n.comments), null != video_views && $youmaxPlayBox.find(".media-views").html('<i class="fa fa-heart"></i>' + video_likes + " " + n.likes)) : (null != video_likes && $youmaxPlayBox.find(".media-likes").html('<i class="fa fa-heart"></i>' + video_likes + " " + n.likes), null != video_views && $youmaxPlayBox.find(".media-views").html('<i class="fa fa-video-camera"></i>' + video_views + " " + n.views)), null != video_uploaded && $youmaxPlayBox.find(".media-uploaded").html('<i class="fa fa-clock-o"></i>' + video_uploaded), $descriptionBox = $youmaxPlayBox.find(".photo-popup-description"), $descriptionBox.height() < 250 ? $youmaxPlayBox.find(".youmax-full-description-button-wrapper").hide() : $youmaxPlayBox.find(".youmax-full-description-button").click(function() {
                    $descriptionBox.removeClass("photo-popup-description-limited"), e(this).hide()
                }), $youmaxPlayBox.find(".youmax-show-button.youmax-popup-show-button").attr("id", video_id_with_type).show(), $youmaxPlayBox.find(".youmax-show-button.youmax-popup-show-button").data("channelid", channel_id), $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-more-button").data("start-index", 1), $youmaxPlayBox.find("#youmax-encloser-comment-holder").hide(), o.autoLoadComments && le(video_id_with_type, i), video_type = video_id_with_type.substring(0, video_id_with_type.indexOf("_")), video_id = video_id_with_type.substring(video_id_with_type.indexOf("_") + 1), "video" == o.shareLink ? "youtube" == video_type ? shareLink = "https://youtu.be/" + video_id : "vimeo" == video_type ? shareLink = "https://vimeo.com/" + video_id : shareLink = window.location.href : shareLink = window.location.href, config = {
                    networks: {
                        facebook: {
                            app_id: o.facebookAppId
                        },
                        email: {
                            enabled: !1
                        },
                        pinterest: {
                            enabled: !1
                        }
                    },
                    ui: {
                        flyout: "top center",
                        button_text: '<i class="fa fa-2x fa-share-alt"></i>'
                    },
                    url: shareLink
                }, new Share(".youmax-share-video-button", config).open()
            }, 100)
        },
        ie = function(t, i, o, n, a) {
            var s = n.data("youmax_global_options"),
                r = n.data("youmax_translator_text");
            s.showTextInsteadOfIcons ? (youmaxExtraPopupClasses = "youmax-text-instead-of-icons", youmaxShowCommentsText = "Show Comments", youmaxMoreCommentsText = "Load More Comments") : (youmaxExtraPopupClasses = "", youmaxShowCommentsText = '<i class="fa fa-comments fa-3x"></i>', youmaxMoreCommentsText = '<i class="fa fa-plus fa-3x"></i>'), n.find("#youmax-encloser").empty().append('<div class="fluid-width-video-wrapper" style="padding-top:' + 100 * s.aspectRatio + '%;"><iframe id="youmax-encloser-video" style="width:100%;" src="" frameborder="0" allowfullscreen></iframe></div><div id="youmax-encloser-comment-wrapper"> <div id="photo-detail-holder"><div class="photo-popup-title"></div><div class="photo-popup-description photo-popup-description-limited"></div><div class="youmax-full-description-button-wrapper"><div class="youmax-full-description-button">More..</div></div><div class="photo-popup-stats"><div class="media-views"></div><div class="media-likes"> </div><div class="media-uploaded"></div> <div type="button" class="youmax-share-video-button"><i class="fa fa-share-alt fa-2x"></i></div></div>  <div class="youmax-show-button-wrapper"><div class="youmax-encloser-comment-button youmax-show-button youmax-popup-show-button">' + youmaxShowCommentsText + '</div></div> <div id="youmax-encloser-comment-holder" class="youmax-encloser-comment-holder-popup"><div class="youmax-video-comment youmax-commentbox-holder"><textarea class="youmax-comment-textbox" placeholder="' + r.thoughts + '"></textarea><button type="button" class="youmax-add-comment-button"><i class="fa fa-google-plus fa-2x"></i><span class="youmax-google-login-text">Login</span></button></div><div id="youmax-encloser-comments"></div><div class="youmax-encloser-comment-button youmax-more-button">' + youmaxMoreCommentsText + "</div></div></div> </div>"), $youmaxEncloserIframe = n.find("#youmax-encloser-video"), $youmaxEncloserIframe.attr("src", ""), $youmaxEncloserIframe.parents("#youmax-encloser").show(), video_id_with_type = t.attr("id"), video_type = video_id_with_type.substring(0, video_id_with_type.indexOf("_")), video_id = video_id_with_type.substring(video_id_with_type.indexOf("_") + 1), frame_source = oe(video_id, video_type, a, s), $youmaxEncloserIframe.attr("src", frame_source), te(t, n), i && e("html, body").animate({
                scrollTop: $youmaxEncloserIframe.offset().top - 50
            }, "slow"), "newpage" == s.displayVideo && (s.linkNewPages && o ? -1 == location.href.indexOf("?v=") && -1 == location.href.indexOf("&v=") ? location.href += (location.search.length ? "&" : "?") + "v=" + video_id_with_type : (location_href = location.href.match(/(v=.+?)($|&)/, ""), location.href = location.href.replace(location_href[1], "v=" + video_id_with_type)) : (n.find("#youmax-video-list-div li").remove(), n.find("#youmax-video-list-div").css("height", "20px"), n.find(".youmax-tab-hover").removeClass("youmax-tab-hover"), n.find(".youmax-encloser-comment-button.youmax-show-button").click(), n.find("#youmax-showing-title").empty().hide()))
        },
        oe = function(e, t, i, o) {
            var n = "";
            return "youtube" == t ? (i ? (e = e.substring(e.indexOf("playlist_videos_") + 16), n = o.videoProtocol + "//www.youtube.com/embed?listType=playlist&list=" + e + "&rel=0") : n = o.videoProtocol + "//www.youtube.com/embed/" + e + "?rel=0", o.autoPlayVideo && (n += "&autoplay=1"), n += o.showTitleInVideoPlayer ? "&showinfo=1" : "&showinfo=0", n += "&theme=" + o.videoPlayerTheme) : "vimeo" == t && (n = o.videoProtocol + "//player.vimeo.com/video/" + e, o.autoPlayVideo && (n += "?autoplay=1")), n
        },
        ne = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxResults;
            null != i && (n = "&pageToken=" + i, a = !0), $searchTab = e("#" + t), restrictedChannels = $searchTab.data("restricttochannels"), relatedTo = $searchTab.data("relatedto"), searchQuery = $searchTab.data("searchquery"), searchOrder = $searchTab.data("searchorder"), eventType = $searchTab.data("eventtype");
            var d = [],
                u = "";
            null != searchQuery && "" != searchQuery && (searchQuery = searchQuery.replace(/ /g, "%20"), u = "&q=" + searchQuery);
            var c = "";
            null != relatedTo && "" != relatedTo && (c = "&relatedToVideoId=" + relatedTo);
            var p = "",
                m = !1;
            null != eventType && "" != eventType && (p = "&eventType=" + eventType, m = !0);
            var h = "";
            null != searchOrder && "" != searchOrder && (h = "&order=" + searchOrder);
            var f = "";
            null != restrictedChannels && "" != restrictedChannels && (f = "&channelId=" + restrictedChannels), d.push("https://www.googleapis.com/youtube/v3/search?part=snippet" + u + c + p + h + f + "&type=video&maxResults=" + l + n + "&key=" + r), apiPlaylistVideosURL = d[0], e.ajax({
                url: apiPlaylistVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    G(e, o, !1, m, a)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            })
        },
        ae = function(t, i, o) {
            var n = "",
                a = !1,
                s = o.data("youmax_global_options"),
                r = s.apiKey,
                l = s.maxResults;
            if (null != i && (n = "&pageToken=" + i, a = !0), null != t && "" != t.trim()) {
                t = t.trim().replace(/ /g, "%20");
                var d = "";
                "channel" == s.searchBoxScope && (d = "&channelId=" + s.channelId), apiSearchURL = "https://www.googleapis.com/youtube/v3/search?part=snippet&q=" + t + "&order=relevance" + d + "&type=video&maxResults=" + l + n + "&key=" + r, e.ajax({
                    url: apiSearchURL,
                    type: "GET",
                    async: !0,
                    cache: !0,
                    dataType: "jsonp",
                    success: function(e) {
                        Y(e, t, a, o)
                    },
                    error: function(e) {
                        alert(e)
                    },
                    beforeSend: O
                }), null != s.playlistSearchFile && "" != s.playlistSearchFile && e.ajax({
                    url: s.playlistSearchFile,
                    type: "GET",
                    async: !0,
                    cache: !0,
                    dataType: "json",
                    success: function(e) {
                        se(e, t, a, o)
                    },
                    error: function(e) {},
                    beforeSend: O
                })
            }
        },
        se = function(t, i, o, n) {
            var a = n.data("youmax_global_options");
            searchList = t.searchList, searchQueryList = i.toLowerCase().split("%20"), searchResult = [];
            for (var s = 0; s < searchList.length; s++)
                for (var r = 0; r < searchQueryList.length; r++) {
                    if (-1 != searchList[s].videoTitle.indexOf(searchQueryList[r])) {
                        searchResult.push(searchList[s].videoId);
                        break
                    }
                    if (-1 != searchList[s].videoDescription.indexOf(searchQueryList[r])) {
                        searchResult.push(searchList[s].videoId);
                        break
                    }
                }
            searchResult.length > 0 && (apiGetVideosURL = "https://www.googleapis.com/youtube/v3/videos?part=snippet&id=" + searchResult + "&key=" + a.apiKey, e.ajax({
                url: apiGetVideosURL,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "jsonp",
                success: function(e) {
                    G(e, n, !0, null, o)
                },
                error: function(e) {
                    alert(e)
                },
                beforeSend: O
            }))
        },
        re = function(e) {
            e.find("#youmax-video-list-div>ul").empty(), e.find("#youmax-encloser").empty(), e.find("#youmax-encloser-video").attr("src", ""), e.find("#youmax-video-list-div>ul").append('<div class="youmax-loading-div" style="text-align:center; height:200px; font:14px Calibri;"><span style="opacity:0;">.</span><br><br><br><br>loading HD...<br><br><br><br><br><br><span style="opacity:0;">.</span></div>'), e.find("#youmax-showing-title").empty().hide()
        },
        le = function(t, i) {
            var o = i.data("youmax_global_options");
            "popup" == o.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = i, video_type = t.substring(0, t.indexOf("_")), video_id = t.substring(t.indexOf("_") + 1), $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-show-button").hide(), $youmaxPlayBox.find("#youmax-encloser-comment-holder").show(), $youmaxPlayBox.find("#youmax-encloser-comments").empty().append("<div class='youmax-loading-comments-div'>loading...</div>"), "youtube" == video_type ? p(video_id, i) : "vimeo" == video_type && (m(video_id, i), $youmaxPlayBox.find(".youmax-comment-textbox").attr("disabled", "disabled").addClass("youmax-disabled"), $youmaxPlayBox.find(".youmax-add-comment-button").attr("disabled", "disabled").addClass("youmax-disabled"))
        },
        de = function(t) {
            var i = t.data("youmax_global_options");
            "popup" == i.displayVideo ? $youmaxPlayBox = e(".youmax-popup.mfp-gallery") : $youmaxPlayBox = t;
            var o = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-more-button");
            o.addClass("youmax-load-more-comments-clicked"), i.showTextInsteadOfIcons ? o.html("Loading..") : o.html('<i class="fa fa-ellipsis-h fa-3x"></i>');
            var n = o.data("nextpagetoken");
            null != n && "undefined" != n && "" != n ? (video_id_with_type = $youmaxPlayBox.find(".youmax-encloser-comment-button.youmax-show-button").attr("id"), video_type = video_id_with_type.substring(0, video_id_with_type.indexOf("_")), video_id = video_id_with_type.substring(video_id_with_type.indexOf("_") + 1), "youtube" == video_type ? p(video_id, t, n) : "vimeo" == video_type && m(video_id, t, n)) : (o.removeClass("youmax-load-more-comments-clicked"), i.showTextInsteadOfIcons ? o.html("All Done") : o.html('<i class="fa fa-close fa-3x"></i>'))
        },
        ue = function(i, s) {
            cache = [], s.data("cache", cache), s.removeClass("newpage"), s.find("#youmax-encloser").hide(), s.find("#youmax-encloser-video").attr("src", ""), re(s), -1 != i.indexOf("youtube_channel_uploads_") ? (innerId = i.substring(24), t(innerId, null, s)) : -1 != i.indexOf("youtube_channel_playlists_") ? (innerId = i.substring(26), f(innerId, null, s)) : -1 != i.indexOf("youtube_channel_search_") ? ne(i, null, s) : -1 != i.indexOf("youtube_channel_events_") ? (innerId = i.substring(23), l(innerId, null, s)) : -1 != i.indexOf("youtube_playlist_videos_") ? (innerId = i.substring(24), t(innerId, null, s)) : -1 != i.indexOf("vimeo_user_videos_") ? (innerId = i.substring(18), o(innerId, null, s)) : -1 != i.indexOf("vimeo_channel_videos_") ? (innerId = i.substring(21), n(innerId, null, s)) : -1 != i.indexOf("vimeo_group_videos_") ? (innerId = i.substring(19), a(innerId, null, s)) : -1 != i.indexOf("vimeo_album_videos_") ? (innerId = i.substring(19), r(innerId, null, s)) : -1 != i.indexOf("query_") && (innerId = i.substring(6), ae(innerId, null, s)), s.find(".youmax-tab").removeClass("youmax-tab-hover"), e("#" + i).addClass("youmax-tab-hover"), s.find("#youmax-select").val(i)
        },
        ce = function(e) {
            var t = e.data("youmax_global_options"),
                i = {
                    search: "Search",
                    uploads: "Uploads",
                    playlists: "Playlists",
                    events: "Events",
                    views: "views",
                    likes: "likes",
                    videos: "videos",
                    subscribers: "subscribers",
                    year: "year",
                    years: "years",
                    month: "month",
                    months: "months",
                    day: "day",
                    days: "days",
                    hour: "hour",
                    hours: "hours",
                    ago: "ago",
                    now: "just now",
                    thoughts: "Share your Thoughts...",
                    comments: "comments"
                };
            e.data("youmax_translator_text", i), null != t.translatorFile && "" != t.translatorFile ? pe(e) : he(e)
        },
        pe = function(t) {
            var i = t.data("youmax_global_options");
            e.ajax({
                url: i.translatorFile,
                type: "GET",
                async: !0,
                cache: !0,
                dataType: "json",
                success: function(e) {
                    me(e, t)
                },
                error: function(e) {
                    he(t)
                },
                beforeSend: O
            })
        },
        me = function(e, t) {
            youmax_translator_text = e.translator, t.data("youmax_translator_text", youmax_translator_text), he(t)
        },
        he = function(e) {
            y(e), xe(e), fe(e), ve(e)
        },
        fe = function(e) {
            var t = e.data("youmax_global_options");
            if ($tabContainer = e.find("#youmax-tabs"), $selectConatiner = e.find("#youmax-select"), null != t.youtube_channel_uploads)
                for (i = 0; i < t.youtube_channel_uploads.length; i++) t.doNotSelectTabsByDefault && (t.youtube_channel_uploads[i].selected = !1), channelId = ye(t.youtube_channel_uploads[i].url, "youtube_channel_uploads_", e, t.youtube_channel_uploads[i].selected), $tabContainer.append('<span id="youtube_channel_uploads_' + channelId + '" class="youmax-tab" >' + t.youtube_channel_uploads[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="youtube_channel_uploads_' + channelId + '" class="youmax-option-highlight" >' + t.youtube_channel_uploads[i].name.replace(/%20/g, " ") + "</option>");
            if (null != t.youtube_channel_playlists)
                for (i = 0; i < t.youtube_channel_playlists.length; i++) t.doNotSelectTabsByDefault && (t.youtube_channel_playlists[i].selected = !1), channelId = ye(t.youtube_channel_playlists[i].url, "youtube_channel_playlists_", e, t.youtube_channel_playlists[i].selected), $tabContainer.append('<span id="youtube_channel_playlists_' + channelId + '" class="youmax-tab" >' + t.youtube_channel_playlists[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="youtube_channel_playlists_' + channelId + '" class="youmax-option-highlight" >' + t.youtube_channel_playlists[i].name.replace(/%20/g, " ") + "</option>"), t.youtube_channel_playlists[i].selected && $tabContainer.find("#youtube_channel_playlists_" + channelId).click();
            if (null != t.youtube_channel_events)
                for (i = 0; i < t.youtube_channel_events.length; i++) t.doNotSelectTabsByDefault && (t.youtube_channel_events[i].selected = !1), channelId = ye(t.youtube_channel_events[i].url, "youtube_channel_events_", e, t.youtube_channel_events[i].selected), $tabContainer.append('<span id="youtube_channel_events_' + channelId + '" class="youmax-tab" >' + t.youtube_channel_events[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="youtube_channel_events_' + channelId + '" class="youmax-option-highlight" >' + t.youtube_channel_events[i].name.replace(/%20/g, " ") + "</option>"), t.youtube_channel_events[i].selected && $tabContainer.find("#youtube_channel_events_" + channelId).click();
            if (null != t.youtube_channel_search)
                for (i = 0; i < t.youtube_channel_search.length; i++) dataString = "", suffix = (new Date).getTime(), t.doNotSelectTabsByDefault && (t.youtube_channel_search[i].selected = !1), null != t.youtube_channel_search[i].restrictToChannels ? (channelId = ye(t.youtube_channel_search[i].restrictToChannels, "youtube_channel_search_" + suffix, e, t.youtube_channel_search[i].selected), dataString += ' data-restricttochannels="' + channelId + '"') : dataString += ' data-restricttochannels=""', null != t.youtube_channel_search[i].relatedTo ? (s = t.youtube_channel_search[i].relatedTo.indexOf("/watch?v="), -1 != s ? (videoId = t.youtube_channel_search[i].relatedTo.substring(s + 9), dataString += ' data-relatedto="' + videoId + '"') : dataString += ' data-relatedto=""') : dataString += ' data-relatedto=""', null != t.youtube_channel_search[i].searchQuery ? dataString += ' data-searchquery="' + t.youtube_channel_search[i].searchQuery + '"' : dataString += ' data-searchquery=""', null != t.youtube_channel_search[i].searchOrder ? dataString += ' data-searchorder="' + t.youtube_channel_search[i].searchOrder + '"' : dataString += ' data-searchorder="date"', null != t.youtube_channel_search[i].eventType ? dataString += ' data-eventtype="' + t.youtube_channel_search[i].eventType + '"' : dataString += ' data-eventtype=""', $tabContainer.append('<span id="youtube_channel_search_' + suffix + '" class="youmax-tab" ' + dataString + " >" + t.youtube_channel_search[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="youtube_channel_search_' + suffix + '" class="youmax-option-highlight" ' + dataString + " >" + t.youtube_channel_search[i].name.replace(/%20/g, " ") + "</option>"), t.youtube_channel_search[i].selected && $tabContainer.find("#youtube_channel_search_" + suffix).click();
            if (null != t.youtube_playlist_videos)
                for (i = 0; i < t.youtube_playlist_videos.length; i++) t.doNotSelectTabsByDefault && (t.youtube_playlist_videos[i].selected = !1), s = t.youtube_playlist_videos[i].url.indexOf("list="), -1 != s ? playlistId = t.youtube_playlist_videos[i].url.substring(s + 5) : (playlistId = "null", alert("Could Not List Videos.." + t.youtube_playlist_videos[i].url)), $tabContainer.append('<span id="youtube_playlist_videos_' + playlistId + '" class="youmax-tab" >' + t.youtube_playlist_videos[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="youtube_playlist_videos_' + playlistId + '" class="youmax-option-highlight" >' + t.youtube_playlist_videos[i].name.replace(/%20/g, " ") + "</option>"), t.youtube_playlist_videos[i].selected && $tabContainer.find("#youtube_playlist_videos_" + playlistId).click();
            if (null != t.vimeo_user_videos)
                for (i = 0; i < t.vimeo_user_videos.length; i++) t.doNotSelectTabsByDefault && (t.vimeo_user_videos[i].selected = !1), s = t.vimeo_user_videos[i].url.indexOf("vimeo.com/"), -1 != s ? vimeoId = t.vimeo_user_videos[i].url.substring(s + 10) : (vimeoId = "null", alert("Could Not Find Vimeo User.." + t.vimeo_user_videos[i].url)), $tabContainer.append('<span id="vimeo_user_videos_' + vimeoId + '" class="youmax-tab" >' + t.vimeo_user_videos[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="vimeo_user_videos_' + vimeoId + '" class="youmax-option-highlight" >' + t.vimeo_user_videos[i].name.replace(/%20/g, " ") + "</option>"), t.vimeo_user_videos[i].selected && $tabContainer.find("#vimeo_user_videos_" + vimeoId).click();
            if (null != t.vimeo_channel_videos)
                for (i = 0; i < t.vimeo_channel_videos.length; i++) t.doNotSelectTabsByDefault && (t.vimeo_channel_videos[i].selected = !1), s = t.vimeo_channel_videos[i].url.indexOf("vimeo.com/channels/"), -1 != s ? vimeoId = t.vimeo_channel_videos[i].url.substring(s + 19) : (vimeoId = "null", alert("Could Not Find Vimeo User.." + t.vimeo_channel_videos[i].url)), $tabContainer.append('<span id="vimeo_channel_videos_' + vimeoId + '" class="youmax-tab" >' + t.vimeo_channel_videos[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="vimeo_channel_videos_' + vimeoId + '" class="youmax-option-highlight" >' + t.vimeo_channel_videos[i].name.replace(/%20/g, " ") + "</option>"), t.vimeo_channel_videos[i].selected && $tabContainer.find("#vimeo_channel_videos_" + vimeoId).click();
            if (null != t.vimeo_group_videos)
                for (i = 0; i < t.vimeo_group_videos.length; i++) t.doNotSelectTabsByDefault && (t.vimeo_group_videos[i].selected = !1), s = t.vimeo_group_videos[i].url.indexOf("vimeo.com/groups/"), -1 != s ? vimeoId = t.vimeo_group_videos[i].url.substring(s + 17) : (vimeoId = "null", alert("Could Not Find Vimeo Group.." + t.vimeo_group_videos[i].url)), $tabContainer.append('<span id="vimeo_group_videos_' + vimeoId + '" class="youmax-tab" >' + t.vimeo_group_videos[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="vimeo_group_videos_' + vimeoId + '" class="youmax-option-highlight" >' + t.vimeo_group_videos[i].name.replace(/%20/g, " ") + "</option>"), t.vimeo_group_videos[i].selected && $tabContainer.find("#vimeo_group_videos_" + vimeoId).click();
            if (null != t.vimeo_album_videos)
                for (i = 0; i < t.vimeo_album_videos.length; i++) t.doNotSelectTabsByDefault && (t.vimeo_album_videos[i].selected = !1), s = t.vimeo_album_videos[i].url.indexOf("vimeo.com/album/"), -1 != s ? vimeoId = t.vimeo_album_videos[i].url.substring(s + 16) : (vimeoId = "null", alert("Could Not Find Vimeo Album.." + t.vimeo_album_videos[i].url)), $tabContainer.append('<span id="vimeo_album_videos_' + vimeoId + '" class="youmax-tab" >' + t.vimeo_album_videos[i].name.replace(/%20/g, " ") + "</span>"), $selectConatiner.append('<option value="vimeo_album_videos_' + vimeoId + '" class="youmax-option-highlight" >' + t.vimeo_album_videos[i].name.replace(/%20/g, " ") + "</option>"), t.vimeo_album_videos[i].selected && $tabContainer.find("#vimeo_album_videos_" + vimeoId).click()
        },
        ye = function(e, t, i, o) {
            return channelId = "null", s = e.indexOf("/user/"), -1 != s ? (channelId = e.substring(s + 6), I(channelId, t, i, o)) : (s = e.indexOf("/channel/"), -1 != s ? (channelId = e.substring(s + 9), "youtube_channel_uploads_" == t && L(channelId, t, i, o)) : alert("Could Not Find Channel.." + e)), channelId
        },
        ve = function(e) {
            var t, i = e.data("youmax_global_options");
            null != i.channel && (t = i.channel.indexOf("/user/"), -1 != t ? (userId = i.channel.substring(t + 6), apiUrl = "https://www.googleapis.com/youtube/v3/channels?part=id&forUsername=" + userId + "&key=" + i.apiKey, T(apiUrl, e)) : (t = i.channel.indexOf("/channel/"), -1 != t ? (channelId = i.channel.substring(t + 9), k(channelId, e)) : alert("Could Not Find Channel..")))
        },
        xe = function(e) {
            var t = e.data("youmax_global_options");
            "newpage" == t.displayVideo && t.linkNewPages && ge(e)
        },
        ge = function(e) {
            if (-1 != location.href.indexOf("v=")) {
                location_href = location.href.match(/v=(.+?)($|&)/, ""), video_id_with_type = location_href[1], video_type = video_id_with_type.substring(0, video_id_with_type.indexOf("_")), video_id = video_id_with_type.substring(video_id_with_type.indexOf("_") + 1), "youtube" == video_type ? u(video_id, e, !1, !1) : "vimeo" == video_type && c(video_id, e, !1, !1);
                var t = e.data("youmax_global_options");
                t.doNotSelectTabsByDefault = !0, e.data("youmax_global_options", t), e.addClass("newpage")
            }
        },
        be = function(e, t) {
            t.removeClass("gt1400 gt1350 gt1300 gt1250 gt1200 gt1150 gt1100 gt1050 gt1000 gt950 gt900 lt1400 lt1350 lt1300 lt1250 lt1200 lt1150 lt1100 lt1050 lt1000 lt950 lt900 lt850 lt800 lt750 lt700 lt650 lt600 lt550 lt500 lt450 lt400"), e > 1250 && t.addClass("gt1400"), e > 1250 && t.addClass("gt1350"), e > 1250 && t.addClass("gt1300"), e > 1250 && t.addClass("gt1250"), e > 1200 && t.addClass("gt1200"), e > 1150 && t.addClass("gt1150"), e > 1100 && t.addClass("gt1100"), e > 1050 && t.addClass("gt1050"), e > 1e3 && t.addClass("gt1000"), e > 950 && t.addClass("gt950"), e > 900 && t.addClass("gt900"), 1250 > e && t.addClass("lt1400"), 1250 > e && t.addClass("lt1350"), 1250 > e && t.addClass("lt1300"), 1250 > e && t.addClass("lt1250"), 1200 > e && t.addClass("lt1200"), 1150 > e && t.addClass("lt1150"), 1100 > e && t.addClass("lt1100"), 1050 > e && t.addClass("lt1050"), 1e3 > e && t.addClass("lt1000"), 950 > e && t.addClass("lt950"), 900 > e && t.addClass("lt900"), 850 > e && t.addClass("lt850"), 800 > e && t.addClass("lt800"), 750 > e && t.addClass("lt750"), 700 > e && t.addClass("lt700"), 650 > e && t.addClass("lt650"), 600 > e && t.addClass("lt600"), 550 > e && t.addClass("lt550"), 500 > e && t.addClass("lt500"), 450 > e && t.addClass("lt450"), 400 > e && t.addClass("lt400")
        };
    e.fn.youmax = function(t) {
        var i = {},
            o = this;
        t.skin = t.skin || "block", i.apiKey = t.apiKey || "AIzaSyDEm5wGLsWi2G3WG40re-DAJcWioQSpJ6o", i.channel = t.channel || "https://www.youtube.com/channel/UC_IRYSp4auq7hKLvziWVH6w", i.clientId = t.clientId || "237485577723-lndqepqthdb3lh4gec2skvpfaii9sgh0.apps.googleusercontent.com", i.maxResults = t.maxResults || 18, i.displayVideo = t.displayVideo || "popup", i.aspectRatio = .5625, i.alwaysUseDropdown = t.alwaysUseDropdown, i.maxPlaylistNameLength = 22, i.autoPlayVideo = t.autoPlayVideo || !1, i.displayFirstVideoOnLoad = t.displayFirstVideoOnLoad || !1, i.linkNewPages = t.linkNewPages || !1, i.videoProtocol = t.videoProtocol || "http:", i.featuredVideo = t.featuredVideo || "", i.searchBoxScope = t.searchBoxScope || "channel", i.autoLoadComments = t.autoLoadComments || !1, i.alignPopupToTop = t.alignPopupToTop, i.commentOrder = t.commentOrder || "time", i.playlistSearchFile = t.playlistSearchFile || "", i.skin = t.skin || "block", i.userWebsite = t.userWebsite || "", i.videoMode = t.videoMode || "wide", i.shareLink = t.shareLink || "video", i.facebookAppId = t.facebookAppId || "", i.widgetMode = t.widgetMode || !1, i.viewCountType = t.viewCountType || "abbr", i.showEvents = t.showEvents || !1, i.likeCommentCountType = t.likeCommentCountType || "abbr", i.loadMode = t.loadMode || "loadmore", i.hideHeader = t.hideHeader || !1, i.hideNavigation = t.hideNavigation || !1, i.loadButtonSize = t.loadButtonSize || "large", i.playlistAction = t.playlistAction || "showvideos", i.videoPlayerTheme = t.videoPlayerTheme || "dark", i.hideComments = t.hideComments || !1, i.minVideoContainerHeight = t.minVideoContainerHeight || 10, i.hideVideoThumbnails = t.hideVideoThumbnails || !1, i.hideLoadMore = t.hideLoadMore || !1, i.showTitleInVideoPlayer = t.showTitleInVideoPlayer, i.translatorFile = t.translatorFile || "", i.hideVideoDetails = t.hideVideoDetails || !1, i.vimeoAccessToken = t.vimeoAccessToken || "c289d754a132ca07051aaf931ef0de33", i.youtube_channel_uploads = t.youtube_channel_uploads, i.youtube_channel_playlists = t.youtube_channel_playlists, i.youtube_channel_events = t.youtube_channel_events, i.youtube_channel_search = t.youtube_channel_search, i.youtube_playlist_videos = t.youtube_playlist_videos, i.vimeo_user_videos = t.vimeo_user_videos, i.vimeo_channel_videos = t.vimeo_channel_videos, i.vimeo_group_videos = t.vimeo_group_videos, i.vimeo_album_videos = t.vimeo_album_videos, i.showVimeoLikesInsteadOfViews = t.showVimeoLikesInsteadOfViews || !1, i.updateLayoutDelay = t.updateLayoutDelay || 500, i.hotThreshold = t.hotThreshold || 300, i.trendingThreshold = t.trendingThreshold || 100, i.minimumFadeTimeout = t.minimumFadeTimeout || 1e3, i.showTopAdSpace = t.showTopAdSpace || !1, i.topAdHtml = t.topAdHtml || "", i.fourColumnContainerWidth = t.fourColumnContainerWidth || "1150px", i.threeColumnContainerWidth = t.threeColumnContainerWidth || "1000px", i.twoColumnContainerWidth = t.twoColumnContainerWidth || "750px", i.oneColumnContainerWidth = t.oneColumnContainerWidth || "500px", i.fiveColumnThumbnailWidth = t.fiveColumnThumbnailWidth || "18%", i.fiveColumnThumbnailLeftRightMargin = t.fiveColumnThumbnailLeftRightMargin || "1%", i.fourColumnThumbnailWidth = t.fourColumnThumbnailWidth || "23%", i.fourColumnThumbnailLeftRightMargin = t.fourColumnThumbnailLeftRightMargin || "1%", i.threeColumnThumbnailWidth = t.threeColumnThumbnailWidth || "30.3%", i.threeColumnThumbnailLeftRightMargin = t.threeColumnThumbnailLeftRightMargin || "1.5%", i.twoColumnThumbnailWidth = t.twoColumnThumbnailWidth || "46%", i.twoColumnThumbnailLeftRightMargin = t.twoColumnThumbnailLeftRightMargin || "2%", i.oneColumnThumbnailWidth = t.oneColumnThumbnailWidth || "95%", i.oneColumnThumbnailLeftRightMargin = t.oneColumnThumbnailLeftRightMargin || "2.5%", i.thumbnailBottomMargin = t.thumbnailBottomMargin || "25px", i.containerLeftRightMargin = t.containerLeftRightMargin || "2%", i.hideDefinition = t.hideDefinition || !1, i.playIconType = t.playIconType || "default", i.showTextInsteadOfIcons = t.showTextInsteadOfIcons || !1, i.maxComments = t.maxComments || 7, i.headerCountType = t.headerCountType || "abbr", o.data("youmax_global_options", i), P = "comma" == i.viewCountType ? D : S, R = "comma" == i.likeCommentCountType ? D : S, M = "comma" == i.headerCountType ? D : S, -1 != i.skin.indexOf("clean") && (i.alwaysUseDropdown = !0), "paginate-sides" == i.loadMode && (i.loadButtonSize = "small", i.playlistAction = "playall"), (null == i.showTitleInVideoPlayer || "" === i.showTitleInVideoPlayer) && (i.showTitleInVideoPlayer = !0), (null == i.alignPopupToTop || "" === i.alignPopupToTop) && (i.alignPopupToTop = !0), (null == i.alwaysUseDropdown || "" === i.alwaysUseDropdown) && (i.alwaysUseDropdown = !0), -1 != i.skin.indexOf("list") && (i.fourColumnContainerWidth = "5000px", i.threeColumnContainerWidth = "5000px", i.twoColumnContainerWidth = "5000px", i.oneColumnContainerWidth = "1400px", i.oneColumnThumbnailWidth = "97%", i.oneColumnThumbnailLeftRightMargin = "1.5%");
        var n = [],
            a = -1,
            s = {
                items: [],
                nextPageToken: "youmax-generated"
            },
            r = [];
        o.data("cache", n), o.data("cacheindex", a), o.data("eventcache", s), o.data("eventcachestatus", r), document.createStyleSheet ? document.createStyleSheet(i.videoProtocol + "//maxcdn.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.min.css") : e("head").append("<link rel='stylesheet' href='" + i.videoProtocol + "//maxcdn.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.min.css' type='text/css' />"), t.maxContainerWidth = t.maxContainerWidth || 1080, o.css("max-width", t.maxContainerWidth + "px");
        var l = "",
            d = "#" + o.attr("id") + " ";
        "wide" == i.videoMode && (l += "#youmax-encloser {max-width: 100% !important;} #youmax-encloser-comment-wrapper {max-width: 880px;margin: 20px auto auto;}"), i.widgetMode && o.addClass("youmax-widget"), i.showTextInsteadOfIcons && o.addClass("youmax-text-instead-of-icons"), i.hideHeader && (l += "#youmax-header{display:none !important;} .youmax-select-box-wrapper {padding-top: 3px;}"), i.hideNavigation && (l += "#youmax-tabs,.youmax-select-box-wrapper,#youmax-select-box{display:none !important;}"), i.hideComments && (l += "#youmax-encloser-comment-holder,.youmax-show-button-wrapper{display:none !important;} .photo-popup-stats {border-bottom: none !important;}"), i.hideVideoDetails && (l += d + ".photo-popup-title," + d + ".photo-popup-description," + d + ".photo-popup-stats{display:none !important;}"), i.hideVideoDetails && i.hideComments && (l += "#photo-detail-holder{display:none !important;}"), i.hideVideoThumbnails && (l += "#youmax-video-list-div{display:none !important;}"), i.hideLoadMore && (l += "#youmax-load-more-div,.youmax-pagination,.youmax-pagination-button-wrapper{display:none !important;}"), i.minVideoContainerHeight > 0 && (l += "#youmax-video-list-div{min-height:" + i.minVideoContainerHeight + "px;}"), i.hideDefinition && (l += ".youmax-definition{display:none !important;}"), "white_grey_combo" == i.playIconType ? l += ".youmax-play-overlay {display: block !important;background-color: rgba(0,0,0,0) !important;} .youmax-play-icon-holder { background-color: rgba(255,255,255,0.85);border: none !important;} .youmax-play-icon-holder i {color: #878787;padding: 15px 0 0 19px !important;font-size: 20px !important;} .youmax-play-hover .youmax-play-icon-holder{transition: 0.3s; background-color: #CF1F1F !important;} .youmax-play-hover i{color: white !important;}" : "white_black_combo" == i.playIconType ? l += ".youmax-play-overlay {display: block !important;} .youmax-play-hover .youmax-play-icon-holder {background-color: #CF1F1F !important;border-color: #CF1F1F !important;} .youmax-play-hover.youmax-play-overlay {background-color: rgba(0,0,0,0);}" : "no_icon" == i.playIconType && (l += ".youmax-play-overlay {display: none !important;}"), be(o.width(), o), l += ".youmax-grid-item {margin-bottom: " + i.thumbnailBottomMargin + ";} #youmax-video-list-div {padding-left: " + i.containerLeftRightMargin + ";padding-right: " + i.containerLeftRightMargin + ";}", i.fourColumnContainerWidth = i.fourColumnContainerWidth.replace("px", ""), l += ".gt" + i.fourColumnContainerWidth + " .youmax-grid-item {width: " + i.fiveColumnThumbnailWidth + "; margin-left: " + i.fiveColumnThumbnailLeftRightMargin + "; margin-right: " + i.fiveColumnThumbnailLeftRightMargin + ";} .lt" + i.fourColumnContainerWidth + " .youmax-grid-item {width: " + i.fourColumnThumbnailWidth + "; margin-left: " + i.fourColumnThumbnailLeftRightMargin + ";margin-right: " + i.fourColumnThumbnailLeftRightMargin + ";}", i.threeColumnContainerWidth = i.threeColumnContainerWidth.replace("px", ""), l += ".lt" + i.threeColumnContainerWidth + " .youmax-grid-item {width: " + i.threeColumnThumbnailWidth + "; margin-left: " + i.threeColumnThumbnailLeftRightMargin + ";margin-right: " + i.threeColumnThumbnailLeftRightMargin + ";}", i.twoColumnContainerWidth = i.twoColumnContainerWidth.replace("px", ""), l += ".lt" + i.twoColumnContainerWidth + " .youmax-grid-item {width: " + i.twoColumnThumbnailWidth + "; margin-left: " + i.twoColumnThumbnailLeftRightMargin + ";margin-right: " + i.twoColumnThumbnailLeftRightMargin + ";}", i.oneColumnContainerWidth = i.oneColumnContainerWidth.replace("px", ""), l += ".lt" + i.oneColumnContainerWidth + " .youmax-grid-item {width: " + i.oneColumnThumbnailWidth + "; margin-left: " + i.oneColumnThumbnailLeftRightMargin + ";margin-right: " + i.oneColumnThumbnailLeftRightMargin + ";}", "block1" == i.skin ? l += "span.youmax-view-date-holder, .youmax-like-comment-holder {display: none !important;} #tiles li p {padding-bottom: 5px !important;} .youmax-duration {bottom: 125px !important;}" : "block2" == i.skin ? l += ".youmax-like-comment-holder {display: none !important;} #tiles li p {padding-bottom: 6px !important;} .youmax-duration {bottom: 163px !important;}" : "block3" == i.skin ? l += "span.youmax-view-date-holder {display: none !important;} #tiles li p {padding-bottom: 6px !important;} .youmax-duration {bottom: 155px !important;}" : "block4" == i.skin ? l += "#tiles li p, .youmax-like-comment-holder {display: none !important;} .youmax-duration {bottom: 10px !important;}" : "trend1" == i.skin ? l += "span.youmax-trend-holder, .youmax-thumbnail-link, .youmax-trend-link-holder {display: none !important;} span.youmax-title-desc-holder {margin-bottom: 5px;}.youmax-duration {bottom: 165px !important;}" : "trend2" == i.skin ? l += "span.youmax-view-date-holder {display: none !important;} span.youmax-trend-link-holder {border-top: 1px solid #e2e2e2;} span.youmax-trend-link-holder {padding-top: 5px;margin-top: 6px;} #tiles li p {padding-bottom: 5px !important;} .youmax-duration {bottom: 170px !important;}" : "grey1" == i.skin || "white1" == i.skin || "blue1" == i.skin ? l += "span.youmax-view-date-holder {display: none !important;} span.youmax-video-list-title {height: 52px !important; padding-top: 4px !important;} .youmax-duration {bottom: 75px !important;}" : "list1" == i.skin && (l += "span.youmax-view-date-holder {display: none !important;} .youmax-title-desc-holder {height: 120px !important;} .youmax-video-list-description { max-height: 80px !important;} .lt700 .youmax-title-desc-holder {height: 100px !important;} .lt700 .youmax-video-list-description {max-height: 60px !important;} .lt600 .youmax-video-list-description {display: inline-block !important;}"), e("head").append("<style class='youmax-added-styles'>" + l + "</style>"), ce(o);
        var u = document.documentElement;
        return u.setAttribute("data-useragent", navigator.userAgent), this
    }
}(jQuery);